import { Component, Inject, OnInit, ViewChild, ChangeDetectorRef, ViewChildren, QueryList, ElementRef  } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ProjectDiagramationVobosConfigComponent } from '../project-diagramation-vobos-config/project-diagramation-vobos-config.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProjectsService } from 'src/app/services/projects.service';
import { MainService } from 'src/app/services/main.service';
import { CutoffService } from 'src/app/services/cutoff.service';
import Swal from 'sweetalert2';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ProjectModel, ProjectVobo } from 'src/app/models/project.model';
import { MatStepper } from '@angular/material/stepper';
import * as ExcelJS from 'exceljs';
import { InventorysService } from 'src/app/services/inventory.service';
import { ProjectDiagramationImagesComponent } from '../project-diagramation-images/project-diagramation-images.component';
import { C } from '@angular/cdk/keycodes';
import { ProjectAddPlantillaComponent } from '../project-add-plantilla/project-add-plantilla.component';

 
@Component({
  selector: 'app-project-diagramation-add',
  templateUrl: './project-diagramation-add.component.html',
  styleUrls: ['./project-diagramation-add.component.scss']
})
export class ProjectDiagramationAddComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  @ViewChild("paginatorSuc") paginatorSuc!: MatPaginator;
  @ViewChild("sortSuc") sortSuc!: MatSort;
  @ViewChild('stepper') myStepper!: MatStepper;
  @ViewChildren('searchInput') searchInputs!: QueryList<ElementRef<HTMLInputElement>>;
   
  firstFormGroup!: FormGroup;
  secondFormGroup!: FormGroup;
  displayedColumns: string[] = [];
  allColumns: string[] = [];
  displayedColumnsStore: string[] = [];
  allColumnsStore: string[] = [];
  id_proy: number = 0;
  id_camp: number = 0;
  medios: any = [];
  elementos: any = [];
  materiales_dist: any = [];
  hasPositions: boolean = false;
  min_pos: number = 1;
  max_pos: number = 1;
  promotionFile: any = [];
  dspromotionFile: any = [];
  dsstoreFile: any = [];
  storeFile: any = [];
  stores_sel: any = [];
  pop_sel!: any;
  medio_sel!: any;
  config_sel!: any;
  cant_sel: number = 0;
  position_sel: number = 1;
  def_fields_stores: any = ["id", "Plaza", "FarmID", "Nombre"];
  attr_cant!: string;
  arr_cant: any = [];
  cantidad_total: number = 0;
  columnas_total: any = {};
  reglas: any = {};
  arr_reglas: any = [];
  cant_regla: number = 1;
  cant_type!: number; //1 - cantidad fija, 2 - atributo, 3 - prioridad,   
  phases!: any;
  vobos_sel: any = [];
  curr_diagram!: any;
  curr_diagram_sim!: any;
  diagram_sim_pop!: any;
  same_stores: boolean = false;
  edit: boolean = false;
  config_positions: any = [];
  projectDiagramations: any= new Array<ProjectVobo>();
  projectAllDiagramations: any = new Array<ProjectVobo>();
  projectAllDiagramationsNoPos: any = new Array<ProjectVobo>();
  segmentable: boolean = true;
  sucursales_vacias : boolean = true;
  dt_totales:any = [];
  loaded : boolean = false;
  loadingPromotions: boolean = true;
  loadingStores: boolean = false;
  precio_sel: any = [];
  extra_stores_data: any = [];
  cant_pops : number = 0;
  guardandoDiagrama = false;
  selected_medios : Array<any> = [];

  selected_attributes : Array<any> = [];

  selectedFiles: File[] = [];
  formData : FormData = new FormData();
  project: ProjectModel = new ProjectModel();
  images: any = [];

  plantillas: {id: number, nombre: string, phases_vobos: any}[] = [];
  totalPhasesConfiguradas: number = 0;
  id_plantSel: number = 0;
  arrPlantilla: any;
  alertEditPlantilla: boolean = false;
  plantillaSeleccionada: number = 0;

  columnsProm: string[] = [];
  totalColumsProm : string[] = [];
  searchTextProm: string = '';
  id_file: number = 0;
  listSolicitudes : any;
  lisDataSolicitudes: any[] = [];
  formedSolicitudes : any;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
    public dialogRef: MatDialogRef<ProjectDiagramationAddComponent>,
    private fb: FormBuilder,  
    private _router: Router,  
    private projectsS: ProjectsService,
    private main: MainService,
    private _cutoffS : CutoffService, 
    private matDialog: MatDialog,
    private invService : InventorysService,
    private cdr: ChangeDetectorRef) { 
    this.projectDiagramations = data.projectAllDiagramations;
    this.projectAllDiagramations = data.projectAllDiagramations;
      // this.projectAllDiagramations = this.projectAllDiagramations = Object.values(
      //   data.projectAllDiagramations.reduce((acc:any, current:any) => {
      //     const key = current.id_pop; // O el campo que identifique al "grupo" de objetos

      //     if (!acc[key] || current.posicion < acc[key].posicion) {
      //       acc[key] = current;
      //     }
      //     return acc;
      //   }, {} as Record<string, any>)
      // );
      this.id_proy = parseInt(data.id_proy);
      this.id_camp = data.projectData.id_proy_camp;
      this.project = data.projectData;
      this.phases = data.phases;
      this.config_positions = data.config_positions;
      this.curr_diagram = data.curr_diagram;
      this.selected_medios = data.selected_medios;
      this.selected_attributes = data.selected_attributes;
      this.curr_diagram_sim = this.projectAllDiagramations.filter((e:any)=>e.id_medio==this.curr_diagram.id_medio&&e.id_pop==this.curr_diagram.id_pop&&e.posicion==this.curr_diagram.posicion);
      if(this.curr_diagram) this.edit = true;
      this._cutoffS.checkIfSameProjectThenReplace(this.id_camp).then(x=>{
        this.loaded = true;
      });

    }

  poplist: Array<any> = [
    { id: 1, media_id: 1, title: 'Dangler', info: [['Posiciones', '-'], ['Prioridad', '-']], rules: []},
  ];

  selectedPromotions: string[] = [];  // Lista de códigos seleccionados
  selectedStores: any[] = [];  // Lista de sucursales seleccionados

  ngOnInit(): void {
    this.loadingPromotions = true;
    this.loaded = false;
    this.getMedios(); 
    this.getPlantillas(1);
    this.cargarResponsablesVobos();
    this.firstFormGroup = this.fb.group({
      medio: ['', Validators.required],
      elemento_pop : ['', Validators.required],
      position: ['1', Validators.required],//pendiente agregar validacion de position con customValidPosition
      alias : [''],
      comentarios : [''],
      imprime: [true],
      blob: [null]
    });
    this.secondFormGroup = this.fb.group({
      secondCtrl: ['', Validators.required],
    });
    this.dspromotionFile = new MatTableDataSource();
    this.addSpecialFiltersPromo();
    this.refreshDataDiagramationAsync().then(async () => {
      await this.getPromotions(); 
      this.getExtraStoreData();
      this.getImages();
      Swal.close();
    }).catch(err => {
      Swal.close();
    });


  }

  cargarResponsablesVobos() {
    this.selectedVobos = false;
    this.phases.map((e:any)=> {
        e.selected = false;
    });
    this.phases = this.phases.map((phase: any) => ({
       ...phase,
       vobos: phase.vobos.map((vobo: any) => ({
         ...vobo,
         selectedUsers: vobo.users.length == 1 ? [vobo.users[0].id] : [],
         searchTerm: '',
         filteredUsers: [...vobo.users],
       }))
    }));
    this.secondDataLoaded = true;

    if(!this.edit) {
      this.plantillaSeleccionada = 0;
      this.selectedVobos = false;
      this.phases.map((e:any)=> {
        e.selected = false;
      });

      this.phases.forEach((phase:any) => {
        const cumple = phase.vobos.every((vobo:any) => vobo.optional == true || vobo.selectedUsers.length === 1);
        phase.selected = cumple; // si todos cumplen true, si no false
        
          phase.vobos.forEach((vobo:any) => {
            this.onUserSelectionChange(phase.id)
          })
        
      });
      this.selectedVobos = this.phases.every((phase:any) =>
        phase.vobos.every((vobo:any) => vobo.selectedUsers.length === 1)
      );
    } 
    else {
      this.vobos_sel = this.curr_diagram.config_vobos;
      this.phases.map((e:any)=> {
        const obj_vobo = this.vobos_sel.some((v:any)=>v.id==e.id);
        if(obj_vobo) e.selected = true;
      });
      this.selectedVobos = true;

      this.phases = this.phases.map((phase: any) => {
        const matchedPhase = this.vobos_sel.find((sel: any) => sel.id === phase.id);
      
        return {
          ...phase,
          vobos: phase.vobos.map((vobo: any) => {
            const matchedVobo = matchedPhase?.vobos.find((selVobo: any) => selVobo.id === vobo.id);
            return {
              ...vobo,
              selectedUsers: matchedVobo ? matchedVobo.users : []
            };
          })
        };
      });
    }
    this.actualizaLabels();
  }

  ngAfterViewInit() {
    this.dspromotionFile.sort = this.sort;
  }

  refreshDataDiagramation(){
        this.projectsS.getProjectConfig(this.id_proy).subscribe((x: any) => {
        this.projectDiagramations = x.data.diagram_all;
        this. projectAllDiagramations= x.data.diagram_all;
      });
  }

  refreshDataDiagramationAsync(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.projectsS.getProjectConfig(this.id_proy).subscribe({
        next: (x: any) => {
          this.projectDiagramations = x.data.diagram_all;
          this.projectAllDiagramations = x.data.diagram_all;
          resolve();
        },
        error: (err : any) => reject(err)
      });
    });
  }

  filteredMedios : Array<any> = []
  getMedios() {
    this.hasPositions = false;
    this.projectsS.getMedios(this.id_camp).subscribe((x: any) => {
      this.medios = x.data.medios;
      this.main.HideLoading();
      
      if(this.edit) { 
        this.medioSelected(this.curr_diagram.id_medio);
        this.selected_medios.push(this.curr_diagram.id_medio);
      }

      this.filteredMedios = this.filterMedios();
      //this.loaded = true;
    },
    (err:any) => {
      console.log(err);
          this.main.HideLoading();
    })
  }

  filterMedios(){
    return this.medios.filter((x:any)=> this.selected_medios.includes(x.id));
  }

  elementosShow  : any = [];
  getPops(id_medio: number) {
    this.main.ShowLoading();
    //this.hasPositions = false;
    this.projectsS.getPOPs(id_medio).subscribe((x: any) => {
     
    //  const created_diagramations = this.projectDiagramations.filter((e:any)=>e.id_medio==this.medio_sel.id);
    // const created_diagramations_off = this.projectAllDiagramations.filter((e:any)=>e.id_medio==this.medio_sel.id && e.id_proyecto != this.id_proy);
     const created_diagramations_off = this.projectAllDiagramations.filter((e:any)=>e.id_medio==this.medio_sel.id);  
     const used_el = x.data.elementos_pop.map((e:any)=>{ 
        const f = created_diagramations_off.filter((a:any)=> a.pop === e.nombre); 
        return Object.assign({ pop : e.nombre, positions : f.length, id_proy: f.map((d:any)=>d.id_proyecto) }) 
      })
      this.cant_pops = x.data.elementos_pop.length;
      if(this.edit){
        this.elementos = x.data.elementos_pop;
      }else{
        this.elementos = x.data.elementos_pop;
       // this.elementos = x.data.elementos_pop.filter((e:any)=>{ 
       //   return !created_diagramations_off.some((a:any)=> a.id_pop == e.id) 
       //});
        this.elementos = this.elementos.filter((e:any)=>{ 
          const f = used_el.find((a:any)=> a.pop == e.nombre); 
          return ((!e.posiciones || e.posiciones == 0) || f.positions < e.posiciones)
        });
      }
      this.main.HideLoading();
      if( this.elementos.length == 0){
        Swal.fire({
          icon: 'warning',
          title: 'Aviso',
          text: 'No hay elementos disponibles para diagramar en este medio.'
        });
        const curr_data = { 
          medio: 0, 
          elemento_pop: 0,
          position: 0,
          alias: '',
          comentarios: '',
          imprime: true,
          blob : [null]
        };
  
        this.firstFormGroup.setValue(curr_data);

      }
      if( this.elementos.length == 1){
     
        setTimeout(() => {
          this.firstFormGroup.get('elemento_pop')?.setValue(this.elementos[0].id);
          this.firstFormGroup.get('elemento_pop')?.updateValueAndValidity();
          this.popSelected(this.elementos[0].id, false, false);
          this.cdr.detectChanges();
        });
      }

      if(this.edit) { 
        this.popSelected(this.curr_diagram.id_pop,false,true);
      }
       this.cdr.detectChanges();
      //this.loaded = true;
    },
    (err:any) => {
      console.log(err);
      this.main.HideLoading();
    })
  }

  calculateTotalPriceFront(price : number, total : number){
      return price * total;
  }

  debugform(){
    console.log(this.firstFormGroup);
  }

  editValues(){
    const curr_data = { 
        medio: this.curr_diagram.id_medio, 
        elemento_pop: this.curr_diagram.id_pop,
        position: this.curr_diagram.posicion,
        alias: this.curr_diagram.alias,
        comentarios: this.curr_diagram.comentarios,
        imprime: this.curr_diagram.imprime ?? true,
        blob: [null]

      };
      this.firstFormGroup.setValue(curr_data);
      this.cdr.detectChanges();
  }

  addSpecialFiltersPromo(){
    /* this.dspromotionFile.filterPredicate = (data : any, filter :any) => {
      const filters = JSON.parse(filter); 

      for (const column in filters) {
        if (filters[column] && data[column]) {
          const columnValue = data[column].toString().toLowerCase();
          const filterValue = filters[column];
          if (!columnValue.includes(filterValue)) {
            return false; 
          }
        }
      }
      return true; 
    }; */

    this.dspromotionFile.filterPredicate = (data: any, filter: string) => {
      const parsed = JSON.parse(filter);
      const filtrosColumnas = parsed.columnas ?? {};
      const seleccionados = parsed.seleccionados || [];
      const soloSeleccionados = parsed.soloSeleccionados || false;
      const search = parsed.search || '';

      //Filtro por columnas
      for (const column in filtrosColumnas) {
        const filterValue = filtrosColumnas[column];
        if (filterValue) {
          const dataValue = data[column]?.toString().toLowerCase() || '';
          // Se asegura que el valor de la celda exista antes de intentar filtrar.
          if (!(data[column] ?? '').toString().toLowerCase().includes(filterValue)) {
            return false;
          }
        }
      }

      //Filtro por toggle
      if (soloSeleccionados) {
        if (!seleccionados.includes(data['CODIGO PRINCIPAL'])) {
          return false;
        }
      }

      //Filtro global
      if (search) {
        const dataString = Object.values(data)
          .join(' ')
          .toLowerCase();
        if (!dataString.includes(search)) {
          return false;
        }
      }

      return true;
    };
  }
  
  addSpecialFiltersStores(){
    this.dsstoreFile.filterPredicate = (data : any, filter :any) => {
      const filters = JSON.parse(filter); 

      for (const column in filters) {
        if (filters[column] && data[column]) {
          const columnValue = data[column].toString().toLowerCase();
          const filterValue = filters[column];
          if (!columnValue.includes(filterValue)) {
            return false; 
          }
        }
      }
      return true; 
    };
  }

  getPromotions(): Promise<void> {
    return new Promise(async (resolve, reject) => {
      this.loadingPromotions = true;
      this.loaded = false;
      this.projectsS.getPromotionData(this.id_camp).subscribe({
        next: async (x: any) => {
          this.id_file = x.id_file;
          this.promotionFile = x.data;
          const promotion_columns = x.allColumns;

          this.addSpecialFiltersPromo();

          if (this.promotionFile != undefined) {
            this.promotionFile.forEach((row: any, index: number) => {
              row.status = 'normal';
              row.originalIndex = index;
            });
            if (x.columnas.length > 0) {
              this.displayedColumns = x.columnas;
              this.displayedColumns = this.displayedColumns.map(col => col);
              this.loadColumnsByUser(this.id_camp);
              this.columnsProm = promotion_columns.filter((key: string) => key && key.trim() !== '' && key.trim().toUpperCase() !== 'CODIGO PRINCIPAL');
              if (!this.displayedColumns.includes('CODIGO PRINCIPAL')) {
                this.displayedColumns.unshift('CODIGO PRINCIPAL');
              }
              this.allColumns = ['select', ...this.displayedColumns];
            } else {
              const columnSet = new Set<string>();
              this.promotionFile.forEach((row: any) => {
                Object.keys(row).forEach(key => {
                  if (key && key.trim() !== '') columnSet.add(key);
                });
              });
              this.displayedColumns = Array.from(columnSet);
              this.loadColumnsByUser(this.id_camp);
              this.columnsProm = Array.from(columnSet).filter(key => key && key.trim() !== '' && key.trim().toUpperCase() !== 'CODIGO PRINCIPAL');
              if (!this.displayedColumns.includes('CODIGO PRINCIPAL')) {
                this.displayedColumns.unshift('CODIGO PRINCIPAL');
              }
              this.allColumns = ['select', ...this.displayedColumns];
            }

            this.allColumns = this.allColumns.filter(item => item !== "status" && item !== "originalIndex");
            this.columnsProm = this.columnsProm.filter(item => item !== "status" && item !== "originalIndex");

            this.getMundos();
            this.setPromotionsFilter();
            await this.getSolicitudes();
          }
         // this.dspromotionFile = new MatTableDataSource(x.data);
          this.dspromotionFile.data = this.promotionFile;
          this.dspromotionFile.paginator = this.paginator;
          this.dspromotionFile.sort = this.sort;
          this.loaded = true;
          this.loadingPromotions = false;
          this.main.HideLoading();
          resolve();
        },
        error: (err: any) => {
          console.log(err);
          this.loaded = false;
          this.loadingPromotions = false;
          this.main.HideLoading();
          reject(err);
        }
      });
    });
  }

  getExtraStoreData() {

    this.projectsS.getExtraSucData(this.id_camp).subscribe(
      (result:any) => {
        this.main.HideLoading();
       if(result.message == "Success") { 
        this.extra_stores_data = result.data;

       }
      },
      (err:any) => {
        this.main.HideLoading();
        console.log(err);
      }
    )
  }  

  dataPositions : any = [];
  positionsToShow : any;
  inventario_disp_positions = 0;

  getInventory(silent : boolean = false){  //convertir en asincrono y que ocurra antes del proceso dentro de setseconddata para que este metodo ejecute el filtro de sucursales y prellene ANTES para tener cargada la info de las sucursales para evitar doble carga
   return new Promise(async (resolve, reject) => {
    if(!silent){
        this.main.ShowLoading();
    }
    let filtros_sucursal = []
    if(this.pop_sel.sucursales_filtro) filtros_sucursal = JSON.parse(this.pop_sel.sucursales_filtro);
    if(this.medio_sel.sucursales_filtro) filtros_sucursal = [ ...filtros_sucursal, ...JSON.parse(this.medio_sel.sucursales_filtro)];
    this.invService.getInventory(this.id_proy, this.id_camp, this._cutoffS, this.medio_sel.id, this.pop_sel.id, filtros_sucursal, this.selected_attributes).then((res_dt_totales:any)=>{
      if(!silent){
          this.main.HideLoading();
      }

      
      if(this.medio_sel.inventario_type == 1) this.dt_totales = res_dt_totales.filter((rd:any)=>rd.id_medio==this.medio_sel.id &&rd.id_pop==this.pop_sel.id);
      else this.dt_totales = res_dt_totales.filter((rd:any)=>rd.id_medio==this.medio_sel.id&&rd.id_pop==this.pop_sel.id);

      if(this.curr_diagram){ //si no es nuevo entonces...
         this.dt_totales.map((e:any)=> {
         const diag_mat = this.curr_diagram.pop_config.find((d:any)=>d.id_pop_config==e.id_pop_config); 
         if(diag_mat) e.precio = diag_mat.precio });
      }
    
      //ruleset pop por posiciones
       this.dataPositions = [];
       this.inventario_disp_positions = 0;
      //es inventario por posiciones
      //if(this.medio_sel.is_position_type == 1){
        //por pop * antes era solo por pop, ahora es para todos
        //if(this.medio_sel.inventario_type == 2){ 
           this.positionsToShow = this.pop_sel.posiciones;
           let diagramedPositions = [];
            if (this.edit) {
              diagramedPositions = this.projectAllDiagramations.filter(
                (x: any) => x.id_medio == this.medio_sel.id && x.id_pop == this.pop_sel.id && x.id != this.curr_diagram.id
              );
            } else if(this.medio_sel.formato == 3){
              diagramedPositions = this.projectAllDiagramations.filter(
                (x: any) => x.id_medio == this.medio_sel.id
              );
            }
            else {
              diagramedPositions = this.projectAllDiagramations.filter(
                (x: any) => x.id_medio == this.medio_sel.id && x.id_pop == this.pop_sel.id 
              );
            }
            let inventario = 0;
            if( this.positionsToShow ){
                this.dt_totales.map((x:any)=>{    
                     inventario = inventario + (x.tipo == 4? x.inventario_max : x.inventario || 0);    
                });
                
                inventario = inventario * this.positionsToShow
            }


            //suma inventarios por  atributo      
            const dt_totales_sum = this.dt_totales.reduce((acc:any, item:any) => {
              const key = item.atributo;
              
              // Si el atributo no existe en nuestro acumulador, lo creamos (copiando el item)
              if (!acc[key]) {
                acc[key] = { 
                  ...item, 
                  inventario: 0, 
                  disponible: 0,
                  items: []
                };
              }

              // Sumamos los valores al grupo correspondiente
              acc[key].inventario += (item.inventario || 0);
              acc[key].disponible += (item.disponible || 0);
              acc[key].items.push(item);
              return acc;
            }, {});

            this.dt_totales = Object.values(dt_totales_sum);


            diagramedPositions.filter((x:any) => x.id_pop == this.pop_sel.id).map((x:any)=>{
             this.dataPositions.push({
                 nombre : x.pop,
                 seleccionado : x.cantidad,
                 posicion : x.posicion,
                 id_diagrama : x.id,
                 inventario: inventario,
                 diagramado: true,
                 id_pop_config : 0,
                 precio  : 0,
                 atributo : ""
               });
             });

            this.dt_totales.map((x:any)=>{
              this.dataPositions.push({
                nombre: x.tipo==3 || x.tipo == 1 ?x.pop:x.nombre,
                seleccionado : x.seleccionado ||0,
                posicion : this.position_sel,
                id_diagrama : 0,
                inventario :  inventario,
                diagramado: true,
                id_pop_config : x.id_pop_config,
                precio  : x.precio,
                atributo : x.atributo
              });
            });

            //se calcula inventario disponible
              if( this.positionsToShow ){
                  this.inventario_disp_positions = inventario;
                  if(this.medio_sel.formato == 3){
                    diagramedPositions.map((x:any)=>{
                      this.inventario_disp_positions = this.inventario_disp_positions - x.cantidad;
                    });
                  } else {
                    this.dataPositions.map((x:any)=>{
                      this.inventario_disp_positions = this.inventario_disp_positions - x.seleccionado;
                    });
                  }
                  
                    //relleno las pos no diagramados para el display
                    for (let i = 1; i <= this.positionsToShow; i++) {
                          let existe = this.dataPositions.some((pos:any) => pos.posicion === i);
                          if (!existe) {
                            this.dataPositions.push({
                              nombre: "",
                              seleccionado: 0,
                              posicion: i,
                              id_diagrama: undefined,
                              inventario: inventario,   
                              diagramado: false,
                              id_pop_config : 0,
                              precio  : 0,
                              atributo : ""
                            });
                          }
                        }

              }
          
            this.dataPositions.sort((a:any, b:any) => a.posicion - b.posicion);

        //}
      //}
      //console.log(this.dt_totales, "on getInventory", this.dataPositions, this.dt_totales[0].inventario * this.positionsToShow, this.inventario_disp_positions);
      resolve(this.dt_totales);
    });

   });

  }

  posList : Array<number>= [];

  getPositions(el_pops: any, isSecondData = false) {
    const sel_pops = this.elementos.find((e:any)=>e.id == el_pops);

    if(sel_pops?.posiciones) {
      this.max_pos = sel_pops.posiciones;
      this.hasPositions = true;

      this.posList = []
      let diagramedPositions = []
      diagramedPositions = this.projectAllDiagramations.filter(
         (x: any) => (x.id_medio == this.medio_sel.id && x.id_pop == this.pop_sel.id) && (!this.curr_diagram || this.curr_diagram.id !=x.id)
      );

      for (let i = 1; i <= this.max_pos; i++) {
      let existe = diagramedPositions.some((pos:any) => pos.posicion === i);
      if (!existe) {
        this.posList.push(i);
      }
      }

      if(!this.edit){
      if(this.posList.length === 0){
         Swal.fire({
          icon: 'warning',
          title: 'Sin posiciones',
          text: 'Ya no quedan posiciones disponibles para diagramar.'
        });
      }else{
        if(!isSecondData){
            this.position_sel = this.posList[0];
            this.firstFormGroup.get('position')?.setValue(this.posList[0]);
        }
      }
      }

    
    }
    else {
      this.max_pos = 1;
      this.hasPositions = false;
    }
  }
  
  medioSelected(id_media: number) {

    if(id_media == null){
      this.dspromotionFile.data = [...this.promotionFile];
    }
    this.materiales_dist = [];
    this.medio_sel = this.medios.find((e:any)=>e.id==id_media);
    if(this.medio_sel.multiples_promociones){ //para bloquear multiples promociones por medio
      this.processMultiplePromotions(id_media);
    }else{
      this.dspromotionFile.data = [...this.promotionFile];
    }
    this.getPops(id_media);
    if(!this.edit){
      this.hasPositions=false;
    }
  }

  processMultiplePromotions(id_medio: number) {

    this.dspromotionFile.data = [...this.promotionFile];
     let mediaDiagramations : any = [];
    if(this.curr_diagram){
        mediaDiagramations = this.projectAllDiagramations.filter((e: any) => e.id_medio == id_medio && e.id != this.curr_diagram.id);
    } else{
        mediaDiagramations = this.projectAllDiagramations.filter((e: any) => e.id_medio == id_medio);
    }
  
    let usedPromos: string[] = [];    

    mediaDiagramations.forEach((md: any) => {
      
      try {
        const promos = JSON.parse(md.promociones);
        if (Array.isArray(promos)) {
          usedPromos.push(...promos);
        }
      } catch (e) {
        console.error("Error parsing promotions from diagramation:", md);
      }
    });
    const uniqueUsedPromos = [...new Set(usedPromos)];

    this.dspromotionFile.data = this.dspromotionFile.data.filter((promo: any) => !uniqueUsedPromos.includes(promo['CODIGO PRINCIPAL']));

    const removedFromSelection = this.selectedPromotions.filter(p => uniqueUsedPromos.includes(p));
    if (removedFromSelection.length > 0) {
      this.selectedPromotions = this.selectedPromotions.filter(p => !uniqueUsedPromos.includes(p));
      Swal.fire('Atención', `Se han deseleccionado ${removedFromSelection.length} promocion(es) porque ya están en uso en otra diagramación del mismo medio.`, 'warning');
    }
  }

  popSelected(el_pops: any, isSecondData : boolean = false, setEditValues : boolean = false) {
    this.main.ShowLoading();
    this.pop_sel = this.elementos.find((e:any)=>e.id==el_pops);
    this.segmentable = this.medio_sel.segmentable==1;
    this.sucursales_vacias = this.medio_sel.sucursales_vacias;
  
    this.diagram_sim_pop = this.projectAllDiagramations.filter((e:any)=>e.id_medio==this.medio_sel.id&&e.id_pop==el_pops);
    
    if(this.diagram_sim_pop.length > 0) this.same_stores = true;
    else this.same_stores = false;
    this.getPositions(el_pops, isSecondData);
   
    this.projectsS.getPOPConfigs(el_pops).subscribe((x: any) => {
      this.materiales_dist = x.data.configs;
      if(this.edit) { 
        this.setData();
        if(setEditValues){
          this.editValues();
        }
      }
      this.main.HideLoading(); 
      this.cdr.detectChanges();
    },
    (err:any) => {
      console.log(err);
      this.main.HideLoading();
    });
  }

  positionSelected(pos: any) {
    this.position_sel = parseInt(pos.value);
    this.firstFormGroup.get('position')?.setValue(this.position_sel);
    this.cdr.detectChanges();

  }

  isEmpyConfig(json : any) : boolean{
       let empyconfig = true;
       try{
          if(JSON.parse(json)[0].id > 0){
            empyconfig = false;
          }
       }catch(ex){
       }
       return empyconfig;
  }

  configSelected() {
      const columnas_sum:any = {};
      this.arr_reglas = [];
      this.materiales_dist.map((config:any)=> {
      const config_sel = config;
      let r:any = {};
      if(this.medio_sel.formato == 3) {
        r = JSON.parse(this.medio_sel.prioridad_filtro)[0];
        r.cant_type = 4; // de por maximos
       }else if(this.medio_sel.formato == 2) {
        r = JSON.parse(this.medio_sel.prioridad_filtro)[0];
        r.cant_type = 3;
       }
      else if(!config.reglas_distribucion || config.reglas_distribucion.length == 0 || config.reglas_distribucion == "[]" || this.isEmpyConfig(config.reglas_distribucion)) {
        r = {cant_type: 1, multiplicador: config.cantidad, nombre: config.nombre};
       }
      else {
        r = JSON.parse(config_sel.reglas_distribucion)[0];
        r.cant_type = 2;
      }
      r.inventario_type = this.medio_sel.inventario_type;
      r.atributo = r.nombre;
      r.nombre = r.inventario_type==1?this.medio_sel.nombre:(r.inventario_type==2?this.pop_sel.nombre:(r.inventario_type==3?config_sel.nombre:r.atributo))
      r.id_pop_config = config_sel.id;
      this.arr_reglas.push(r);
    });
        

    let arr_fields_stores:any = [];
    this.selected_attributes.forEach(attr => {
      if (!this.def_fields_stores.includes(attr)) {
        this.def_fields_stores.push(attr);
      }
    });
    
    this.arr_cant = [];
    this.arr_reglas.map((e:any)=> {
      if(e.nombre) {
        if(e.atributo) arr_fields_stores.push(e.atributo);
        this.arr_cant.push({
          id_pc: e.id_pop_config,
          nombre: e.nombre,
          atributo: e.atributo,
          cantidad: e.multiplicador,
          tipo: e.cant_type
        });
      }
    });
    const arr_fields_totals = arr_fields_stores;
    arr_fields_stores = this.def_fields_stores.concat(arr_fields_stores);

    let filtros: any = [];
    if(this.pop_sel.sucursales_filtro) filtros = JSON.parse(this.pop_sel.sucursales_filtro);
    if(this.medio_sel.sucursales_filtro) filtros = [ ...filtros, ...JSON.parse(this.medio_sel.sucursales_filtro)];
    this.storeFile = this._cutoffS.filtrarSucursales(filtros).map((e:any)=>{ 
      let obj_store:any = {};
      arr_fields_stores.map((key:string)=> {
        if(arr_fields_totals.includes(key)) {
          if(this.arr_reglas.some((reg:any) => key == reg.nombre && reg.cant_type === 4)){
           columnas_sum[key] =  Number((columnas_sum[key]?columnas_sum[key]:0)) + Number((e[key] || 0));
           obj_store[key]= e[key] || 0;
          }else{
            if(this.arr_reglas.some((reg:any) => key == reg.nombre && reg.cant_type === 1)){
                   const reglaCantidadFija = this.arr_reglas.filter((reg:any) => key == reg.nombre && reg.cant_type === 1)[0];
                   columnas_sum[key] =  Number((columnas_sum[key]?columnas_sum[key]:0)) + Number((reglaCantidadFija.multiplicador || 0));
                   obj_store[key]= reglaCantidadFija.multiplicador || 0;
            }else{
            columnas_sum[key] =  Number((columnas_sum[key]?columnas_sum[key]:0)) + Number((e[key] || 0));
            obj_store[key]= e[key] || 0;
            }
 
          }
          //console.log(key,   columnas_sum[key]);
        }else{
          obj_store[key]= e[key] || '';
        }
      
      });
      return obj_store;
    });



    if((this.medio_sel.formato === 3 || this.medio_sel.formato === 2) && !this.edit){
      const file_suc_full = this._cutoffS.project_cutoff_file_data;     
     
      let ids_suc_sel = this.projectAllDiagramations.filter((e:any)=>e.id_medio==this.medio_sel.id)
      if(this.medio_sel.inventario_type != 1 || this.medio_sel.formato === 2) {
        ids_suc_sel = ids_suc_sel.filter((e:any)=>e.id_pop==this.pop_sel.id)
      }

      ids_suc_sel = ids_suc_sel.map((d: any) => d.pop_config
        .map((pc: any) => pc.sucursales.map((s: any) => s.id)).flat()
      ).flat();

      const sucursalCantidadMap: Record<number, number> = {};

      let added_pops : any [] =[];
      this.projectAllDiagramations.filter((e:any)=>e.id_medio==this.medio_sel.id).forEach((diagram: any) => {
      diagram.pop_config.forEach((pc: any) => {
        pc.sucursales.forEach((s: any) => {
          if (!sucursalCantidadMap[s.id]) {
            sucursalCantidadMap[s.id] = 0;
          }
          const key = `${diagram.id_pop}-${s.id}`; 
          if(this.medio_sel.formato !==3 || !added_pops.includes(key)){
            added_pops.push(key);
             sucursalCantidadMap[s.id] += Number(s.cantidad); // suma cantidades de la misma sucursal
          }
         
        });
      });
      });
      let sucursalesInvalidas : any = []

      if(this.medio_sel.formato === 2 ){
            sucursalesInvalidas = ids_suc_sel.filter((id: number) => {
            const sucursal = file_suc_full.find((s: any) => s.id === id);
            if (!sucursal) return false; // si no se encuentra en file_suc_full, se excluye
            // encontrar el atributo con el formato de maximos
            let atributoMax = Object.keys(sucursal).find(key => key.includes(this.arr_reglas[0].atributo)); 
            if (!atributoMax) return false; // sino tiene atributo max, se excluye
            // obtener el valor máximo permitido
            const maxPermitidoSuc = Number(sucursal[atributoMax]); 
            return sucursalCantidadMap[id] > maxPermitidoSuc; 
          });
        }
        if (!this.same_stores) {
          if(this.medio_sel.formato === 3 ){
              sucursalesInvalidas = ids_suc_sel.filter((id: number) => {
              const sucursal = file_suc_full.find((s: any) => s.id === id);
              if (!sucursal) return false; // si no se encuentra en file_suc_full, se excluye
              // encontrar el atributo con el formato de maximos
              let atributoMax = Object.keys(sucursal).find(key => key.includes(this.arr_reglas.filter((reg:any) =>  reg.cant_type === 4)[0].atributo)); 
              if (!atributoMax) return false; // sino tiene atributo max, se excluye
              // obtener el valor máximo permitido
              const maxPermitido = Number(sucursal[atributoMax]); 
              return sucursalCantidadMap[id] >= maxPermitido; // si es mayor igual es que ya entro en el limite de sucursal, por  lo tanto la sucursal ya no puede salir en la lista
              });
          }

          this.storeFile = this.storeFile.filter((e: any) => !sucursalesInvalidas.includes(e.id));
          if(this.medio_sel.formato === 2 ){
              this.storeFile = this.storeFile.filter((e:any) => e[this.arr_reglas.filter((reg:any) =>  reg.cant_type === 3)[0].atributo] > 0);
          }
          if(this.medio_sel.formato === 3 ){
              this.storeFile = this.storeFile.filter((e:any) => e[this.arr_reglas.filter((reg:any) =>  reg.cant_type === 4)[0].atributo] > 0);
          }
      }
    }
  
    if (!this.same_stores) {
      if(this.medio_sel.multiples_elementos==0&&!this.edit) {
   
        const ids_suc_sel_aux = this.projectAllDiagramations.filter((e:any)=>e.id_medio==this.medio_sel.id).map((d:any)=>d.pop_config.map((pc:any)=>pc.sucursales.map((s:any)=>s.id)).flat()).flat();
        if(ids_suc_sel_aux.length>0) {
          this.storeFile = this.storeFile.filter((e:any)=>!ids_suc_sel_aux.includes(e.id));
        }
      }
    }
  

    this.storeFile = this.storeFile.map((e:any)=> {
      const extra_stores = this.extra_stores_data ? this.extra_stores_data.find((x:any)=> x.id==e.id) : null;
      return Object.assign(extra_stores?extra_stores:{}, e);
    })

    this.columnas_total = {};
    this.arr_cant.map((e:any)=> { 
      if(e.tipo == 1) {
        this.columnas_total[e.nombre] = this.storeFile.length*e.cantidad;
      }else if(e.tipo == 4) {
        this.columnas_total[e.nombre] = this.storeFile.length*e.cantidad;
      }
      else { 
        this.columnas_total[e.nombre] = this.columnas_total[e.nombre] || 0;
        this.columnas_total[e.nombre] += columnas_sum[e.atributo]?columnas_sum[e.atributo]*e.cantidad:0;
      }
    });


    if (this.storeFile.length > 0) {
      this.dsstoreFile = new MatTableDataSource(this.storeFile);
      this.dsstoreFile.paginator = this.paginatorSuc;
      this.dsstoreFile.sort = this.sortSuc;

      this.displayedColumnsStore = arr_fields_stores.filter((key: any) => key && !/\bid\b/.test(key.trim()));
      this.allColumnsStore = ['select', ...this.displayedColumnsStore];
         
      this.setSucursalFilter();
      this.addSpecialFiltersStores();
      this.getPlazas();
  

    //  this.displayedColumnsStore = Object.keys(this.storeFile[0]).filter(key => key && !key.trim().includes("id"));
    //  this.allColumnsStore = ['select', ...this.displayedColumnsStore];
   }else{
       Swal.fire({
          icon: 'warning',
          title: 'Inventario no disponible',
          text: 'No hay inventario disponible para diagramar.'
        });
        this.myStepper.selectedIndex = 0;
    }
  }
  
  setData() {
      this.position_sel =  this.curr_diagram.posicion;
      if(!this.promotionsChange){
        this.selectedPromotions = this.curr_diagram.promociones;
      }
  }

  promotionsChange : boolean = false;
  customValidPosition(control: FormControl): void {
    const positions = this.diagram_sim_pop.map((e:any)=>e.posicion);
    if(positions.includes(this.position_sel)) {
      setTimeout(() => {
          control.setErrors({ myCustomError: true });
      });
    }
  }

  getMedioDescripcion(){
    return this.medios
    .find((x: any) => x.id == this.firstFormGroup.get('medio')?.value)
    ?.descripcion ?? '';
  }

  secondDataLoaded = false;

  setSecondData() {
    this.loadingStores = true;
    this.cdr.detectChanges();

    if(!this.edit){
      this.toggleValue = false;
    }
    const positions = this.diagram_sim_pop.map((e:any)=>e.posicion);
    if(!this.edit &&( (positions.length == this.pop_sel.posiciones && (this.pop_sel.posiciones > 0)) || (this.pop_sel.posiciones>0&&!this.edit&&positions.includes(this.position_sel)))){
        Swal.fire({
          icon: 'warning',
          title: 'Datos incorrectos',
          text: 'Ya existe una diagramación con los datos seleccionados.'
        });
        this.myStepper.selectedIndex = 0;
      } else  {
    this.getInventory(true).then((x:any)=>{
      if(x&&x.length>0&&x[0].seleccionado==x[0].inventario&&!this.same_stores&&!this.edit)
      {
        Swal.fire({
          icon: 'warning',
          title: 'Inventario no disponible',
          text: 'No hay inventario disponible para diagramar.'
        });
        this.myStepper.selectedIndex = 0;
      }
      else {
        this.popSelected(this.firstFormGroup.get("elemento_pop")?.value, true);
      
        this.configSelected();
        if(this.same_stores) {
          this.stores_sel = this.diagram_sim_pop[0].pop_config.map((e:any)=> Object.assign({ id_pc: e.id_pop_config, sucursales: e.sucursales, total: e.cantidad }));
          this.selectedStores = this.diagram_sim_pop[0].pop_config.map((e:any)=>e.sucursales.map((s:any)=>s.id)).flat().filter(this.main.onlyUnique);
        }
        else if(!this.segmentable) {
          //aqui selecciona todos sino hace reglas
          this.toggleSelectionStore(0,{ target: { checked: true }});
        }
        else {
          this.stores_sel = [];
          this.selectedStores = [];
        }
        if(this.edit) { 
          this.stores_sel = this.curr_diagram_sim[0].pop_config.map((e:any)=> Object.assign({ id_diagrama: e.id, id_pc: e.id_pop_config, sucursales: e.sucursales, total: e.cantidad }));
          this.selectedStores = this.curr_diagram_sim[0].pop_config.map((e:any)=>e.sucursales.map((s:any)=>s.id)).flat().filter(this.main.onlyUnique);
          this.preLoadMaterialInfo();
        } 
      }
      this.loadingStores = false;
      this.cdr.detectChanges();
    });
    }
  }

    filterUsers(item: any) {
      const term = (item.searchTerm || '').toLowerCase();
    
      const selectedIds = item.selectedUsers || [];
    
      
      const selectedUsers = item.users.filter((u: any) =>
        selectedIds.includes(u.id)
      );
    
    
      const filtered = item.users.filter((u: any) =>
        !selectedIds.includes(u.id) && u.name.toLowerCase().includes(term)
      );
    
    
      item.filteredUsers = [...selectedUsers, ...filtered];
    }

  clearSearch(item: any): void {
      item.searchTerm = '';
      item.filteredUsers = [...item.users]; // resetear lista
  }

  codigoFilter : string = "";
  mundoFilter : any = "";
  plazasFilter : any = "";

  mundosList : Array<any> = [];
  plazasList : Array<any> = [];

  getMundos(){
    let mundos = this.promotionFile.map((item : any) => item.MUNDO);
    this.mundosList = [...new Set(mundos)];
  }

  getPlazas(){
    let plaza = this.storeFile.map((item : any) => item.Plaza);
    this.plazasList = [...new Set(plaza)].sort((a : any, b :any) => a.localeCompare(b));;
  }

  setPromotionsFilter(){
    this.dspromotionFile = new MatTableDataSource(this.promotionFile);
    this.dspromotionFile.paginator = this.paginator;
    this.dspromotionFile.sort = this.sort;
    this.addSpecialFiltersPromo();
  }

  setSucursalFilter(){
    const sucInv: any = this.getSucsWithInventory();
    //Proceso para filtrar sucursales que tengan invetario total mayor a 0
    const newArrayStore = this.storeFile.filter((obj: any) => {
      return sucInv.some((e:any)=> 
        e.sucursales.some((s:any)=>s.id==obj.id)
      );
    });

    this.dsstoreFile = new MatTableDataSource(newArrayStore);
    this.dsstoreFile.paginator = this.paginatorSuc;
    this.dsstoreFile.sort = this.sortSuc;
    this.addSpecialFiltersStores();
  }

  //filterPlaza(event : any){
  //  this.setSucursalFilter()
  //  this.plazasFilter = event;
  //  if(event != ""){
  //    let storeFileFiltered = [];
  //    storeFileFiltered = this.storeFile.filter((x:any)=> x.Plaza.toString() ==  this.plazasFilter);
  //    this.dsstoreFile = new MatTableDataSource(storeFileFiltered);
  //    this.dsstoreFile.paginator = this.paginatorSuc;
  //    this.dsstoreFile.sort = this.sortSuc;
  //    this.addSpecialFiltersStores();
  //  }
  //}
  
  filtrarPromotions(){
      this.setPromotionsFilter();
      //let promotionFileFiltered = [];
      //promotionFileFiltered = this.promotionFile.filter((x:any)=> x["CODIGO PRINCIPAL"].toString().includes(this.codigoFilter));
      //this.dspromotionFile = new MatTableDataSource(promotionFileFiltered);
  }

  toggleSelection(codigo: string): void {
    const index = this.selectedPromotions.indexOf(codigo);
    if (index > -1) {
      this.selectedPromotions.splice(index, 1);  
    } else {
      this.selectedPromotions.push(codigo); 
    }
    this.promotionsChange = true;
    //console.log("on toggle selection", this.selectedPromotions);
  }

  selectAllValue : boolean = false;
  selectAll(event: any): void {
    if (event.target.checked) {
    let nuevosIds = this.dspromotionFile.filteredData.map((promo: any) => promo['CODIGO PRINCIPAL']);
    nuevosIds.forEach((id: any) => {
      if (!this.selectedPromotions.includes(id)) {
        this.selectedPromotions.push(id);
      }
    });
    } else {
      let idsFiltrados = this.dspromotionFile.filteredData.map((promo: any) => promo['CODIGO PRINCIPAL']);
      this.selectedPromotions = this.selectedPromotions.filter((id: any) => !idsFiltrados.includes(id));
    }
    this.promotionsChange = true;
   // console.log("on select all", this.selectedPromotions);
  }

  toggleValue : boolean = false;

  //inventory changes
  toggleSelectionStore(id: number, event: any): void {
    let index = 0;
    this.stores_sel = [];
    if(id>0){
      index = this.selectedStores.indexOf(id);
      if (index > -1) {
        this.selectedStores.splice(index, 1);
      } else {
        this.selectedStores.push(id); 
      }
    }
    else {
      if (event.target.checked) {
        if(this.dsstoreFile.length != 0){
          let nuevosIds = this.dsstoreFile.filteredData.map((store: any) => store['id']);
          nuevosIds.forEach((id: any) => {
          if (!this.selectedStores.includes(id)) {
            this.selectedStores.push(id);
          }
        });
        }

      } else {
        if(this.dsstoreFile.length != 0){
            let idsFiltrados = this.dsstoreFile.filteredData.map((store: any) => store['id']);
            this.selectedStores = this.selectedStores.filter((id: any) => !idsFiltrados.includes(id));
        }

      }
    }

    let columnas_total_sel:any = {};
    const sel_sf = this.storeFile.filter((e:any)=> this.selectedStores.includes(e.id));
    this.arr_cant.map((e:any)=> {
      e.cantidad = Number(e.cantidad);
      const ob_pc: any = { id_pc: e.id_pc, sucursales: [], total: 0, atributo: e.atributo }
      const get_diagram = this.curr_diagram_sim.find((d:any)=>d.id_pop_config==e.id_pc);
      if(get_diagram) {
        ob_pc.id_diagrama = get_diagram.id;
      }
      
      sel_sf.map((sf:any)=> {
        let cantidad = 0;
        if(e.tipo == 1) {
          cantidad = e.cantidad;
        }
        else if(e.tipo == 2) { 
          cantidad = (sf[e.atributo]?parseInt(sf[e.atributo]):0)*e.cantidad;
        }
        else if(e.tipo == 3) { 
          const cant_pops = this.cant_pops;
          const cant_total_suc = (sf[e.atributo]?parseInt(sf[e.atributo]):0)*e.cantidad;
          const modulo = cant_total_suc%cant_pops;
          const max = Math.ceil(cant_total_suc/cant_pops);
          const min = Math.floor(cant_total_suc/cant_pops);
          const prioridad = this.pop_sel.prioridad;
          cantidad = Number(prioridad<=modulo?max:min); 

        }else if(e.tipo == 4) { 
          
          let sumaSucursalTotal : number = 0;
          let maxValue = this.storeFile.filter((x:any) => x.id == sf.id)[0][this.arr_reglas.filter((reg:any) =>  reg.cant_type === 4)[0].atributo];
          //all 
          if(this.medio_sel.inventario_type != 1) {
            this.projectAllDiagramations.filter((e:any)=>e.id_medio==this.medio_sel.id).filter((e:any)=>e.id_pop==this.pop_sel.id).forEach((diagram: any) => {
            diagram.pop_config.forEach((pc: any) => {
              pc.sucursales.filter((s:any)=> s.id == sf.id).forEach((s: any) => {
                sumaSucursalTotal += s.cantidad; // suma cantidades de la sucursal seleccionada
                });
              });
            });
          }
          else {
            let added_pops : any = []
            this.projectAllDiagramations.filter((e:any)=>e.id_medio==this.medio_sel.id).forEach((diagram: any) => {
            diagram.pop_config.forEach((pc: any) => {
              pc.sucursales.filter((s:any)=> s.id == sf.id).forEach((s: any) => {
              if(this.medio_sel.formato !==3 || !added_pops.includes(diagram.id_pop)){
                   added_pops.push(diagram.id_pop);
                     sumaSucursalTotal += Number(s.cantidad); // suma cantidades de la misma sucursal
                   }
                });
              });
            });
          }

          let valueToAdd = e.cantidad > maxValue ? maxValue : e.cantidad;

          if((sumaSucursalTotal + valueToAdd) > maxValue){
            cantidad = (sumaSucursalTotal + valueToAdd) - maxValue;
          }else{
            cantidad = valueToAdd;
          }
          //redo: reglas de tipo 4
        }
        //this.cant_sel += cantidad;
        columnas_total_sel[e.attributo] += Number(cantidad);

        if(cantidad > 0) {
          ob_pc.sucursales.push({id: sf.id, cantidad});
          //ob_pc.total += cantidad;
       
          ob_pc.total = Number(ob_pc.total) + Number(cantidad); 
        }
      });

      if(ob_pc.sucursales.length > 0) {
        this.stores_sel.push(ob_pc);
      }
    });
    if (id>0) {
      index = this.selectedStores.indexOf(id);
      if(!this.stores_sel.some((s:any)=>s.sucursales.some((suc:any)=>suc.id==id))) {
        this.selectedStores.splice(index, 1);
      }
    }
    
    // this.stores_sel = Array.from(
    //   new Map(this.stores_sel.map((item: any) => [item.atributo, item])).values()
    // );
    this.selectedStores = this.stores_sel.map((e:any)=>e.sucursales.map((s:any)=>s.id)).flat().filter(this.main.onlyUnique);

    //console.log(this.columnas_total);//inventario total
    //console.log(this.stores_sel);//seleccionado
  }
  preloaded = false;
  preLoadMaterialInfo(){
      this.stores_sel = [];
      let columnas_total_sel:any = {};
      const sel_sf = this.storeFile.filter((e:any)=> this.selectedStores.includes(e.id));
      this.arr_cant.map((e:any)=> {
        const ob_pc: any = { id_pc: e.id_pc, sucursales: [], total: 0, atributo: e.atributo }
        const get_diagram = this.curr_diagram_sim.find((d:any)=>d.id_pop_config==e.id_pc);
        if(get_diagram) {
          ob_pc.id_diagrama = get_diagram.id;
        }
        
        sel_sf.map((sf:any)=> {
          let cantidad = 0;
          if(e.tipo == 1) {
            cantidad = e.cantidad;
          }
          else if(e.tipo == 2) { 
            cantidad = (sf[e.atributo]?parseInt(sf[e.atributo]):0)*e.cantidad;
          }
          else if(e.tipo == 3) { 
            const cant_pops = this.elementos.length;
            const cant_total_suc = (sf[e.atributo]?parseInt(sf[e.atributo]):0)*e.cantidad;
            const modulo = cant_total_suc%cant_pops;
            const max = Math.ceil(cant_total_suc/cant_pops);
            const min = Math.floor(cant_total_suc/cant_pops);
            const prioridad = this.pop_sel.prioridad;
            cantidad = prioridad<=modulo?max:min;
          }else if(e.tipo == 4) { 
            cantidad = e.cantidad;
            //añadir regla extra*?
          }
          //this.cant_sel += cantidad;
          columnas_total_sel[e.nombre] += cantidad;
  
          if(cantidad > 0) {
            ob_pc.sucursales.push({id: sf.id, cantidad});
            ob_pc.total += Number(cantidad);
          }
        });
  
        if(ob_pc.sucursales.length > 0) {
          this.stores_sel.push(ob_pc);
        }
      });
      this.selectedStores = this.stores_sel.map((e:any)=>e.sucursales.map((s:any)=>s.id)).flat().filter(this.main.onlyUnique);
      this.stores_sel = Array.from(
        new Map(this.stores_sel.map((item: any) => [item.atributo, item])).values()
      );
      //console.log("totales",this.columnas_total);//inventario total
      //console.log("seleccionado", this.stores_sel);//seleccionado
      this.preloaded = true;
  }

  setColumnasTotalArray(): { material: string; total: number }[] {
    return Object.entries(this.columnas_total).map(([key, value]) => ({
      material: key,
      total: Number(value)
    }));
  }


  findMaterialTotal(material_key : any) : number{
  // if(this.stores_sel.length == 1)
  //   return this.stores_sel[0].total; 
  // else 
    const total = this.stores_sel.reduce((sum:any, item:any) => {
      
        sum += Number(item.total);
      
      return sum;
    }, 0);
    return total;
  }

  openVobosDiagramConfigDialog(phase: any) {
    const obj_vobo = this.vobos_sel.find((e:any)=>e.id==phase.id);
    this.matDialog.open(ProjectDiagramationVobosConfigComponent, {
      panelClass: ['dialogs-lg'],
      data: {
        edit : true,
        phase,
        sel_vobos: obj_vobo 
      }
    }).afterClosed().subscribe(
      (resp) => {
        if(resp) {
          this.setVobo(phase.id, resp);
        }
      }
    );
  }

  seeVobo(vobo: any){
   // console.log(vobo, this.vobos_sel, this.phases);
  }

  onSelectOpened(index: number) {
    setTimeout(() => {
      const input = this.searchInputs.toArray()[index];
      input?.nativeElement?.focus();
    }, 0);
  }

selectedVobos:boolean = false;

setVobo(id: number, v: any) {
  let res_obj: any = {};
  res_obj.id = id;
  res_obj.vobos = [];

  let obj_phase = this.phases.find((e: any) => e.id == id);

  for (const key in v) {
    if (Object.prototype.hasOwnProperty.call(v, key)) {
      const ov = obj_phase.vobos.find((e: any) => e.area == key);
      res_obj.vobos.push({
        id: ov.id,
        users: v[key],
        area: ov.area,
        optional : ov.optional
      });
    }
  }

  const allVobosSelected = obj_phase.vobos.every((vobo: any) => 
   vobo.optional == true || vobo.selectedUsers && vobo.selectedUsers.length > 0
  );

  obj_phase.selected = allVobosSelected;

  const obj_vobo = this.vobos_sel.find((e: any) => e.id == id);
  if (obj_vobo) {
    obj_vobo.vobos = res_obj.vobos;
  } else {
    this.vobos_sel.push(res_obj);
  }

  this.selectedVobos = this.phases.every((x:any)=> x.optional== true || x.selected == true);
  //console.log(this.phases,  this.selectedVobos);
  this.actualizaLabels();
}

    onUserSelectionChange(phaseId: number): void {
      const phase = this.phases.find((p: any) => p.id === phaseId);
      if (!phase) return;
    
     
      let groupedByArea: any = {};
    
      for (const vobo of phase.vobos) {
        groupedByArea[vobo.area] = vobo.selectedUsers || [];
      }
    
      this.setVobo(phaseId, groupedByArea);
    }

  setPrecio(id_pop_config: number, event: any) {
    const precio = Number(event.target.value);
    const obj_precio_sel = this.precio_sel.find((e:any)=>e.id_pop_config==id_pop_config);
    if(obj_precio_sel) {
      obj_precio_sel.precio = precio;
    }
    else {
      this.precio_sel.push({id_pop_config, precio});
    }
    if (this.dt_totales.length > 0) { 
      this.dt_totales.find((m: any) => m.id_pop_config === id_pop_config).precio = precio;
    }
  }

  goToConfig() {
    const url = '/admin/projects/config/' + this.id_proy;
   window.open(url, '_blank');
  }

  resetDiagram(id_medio : number){
    const curr_data = { 
      medio: 0, 
      elemento_pop: 0,
      position: 0,
      alias: '',
      comentarios: '',
      imprime: true,
      blob : [null]
    };
   
    this.firstFormGroup.setValue(curr_data);
    this.main.ShowLoading();
    this.refreshDataDiagramationAsync().then(x=>{
       this.main.HideLoading();
       this.getMedios();
    });
    this.myStepper.selectedIndex = 0;
    this.plantillaSeleccionada = 0;
    this.guardandoDiagrama = false;
  }

  guardarDiagramaSlim(){
        
      let ins_data = { 
        ...this.firstFormGroup.value,
        imprime: this.firstFormGroup.get('imprime')?.value ?? true,
        promociones: this.selectedPromotions,
      };

      if( !this.pop_sel.posiciones || this.pop_sel.posiciones  == 0){
      }else{
        ins_data.position = this.position_sel;
      }

      ins_data.id_diagrama = this.curr_diagram.id;

      this.projectsS.editProjectDiagramSlim(ins_data).subscribe(
          (result:any) => {
            this.main.HideLoading();
            if(result.message == "Success") {

              if(this.selectedFiles.length > 0){
                this.formData.append('id_diagrama', result.id_diagrama);      
               this.selectedFiles.forEach((file, index) => {
                  this.formData.append(`blob_${index}`, file);
                });
                 this.formData.append('folder', this.project.folder as string);  
                this.uploadImages();
              }
              else{
                  Swal.fire({
                  icon: 'success',
                  title: 'Editado',
                  text: 'Diagrama editado correctamente'          
                }).then(() => {            
                  this.dialogRef.close({ reload: true });
                });
              }
              
            }
            else {
               this.main.HideLoading();
               this.guardandoDiagrama = false;
              Swal.fire({
                icon: 'error',
                title: 'Error al guardar',
                text: 'Ocurrió un error al guardar el registro, por favor vuelve a intentarlo.'
              });
            }
          },
          (err:any) => {
            this.main.HideLoading();
                  this.guardandoDiagrama = false;
            console.log(err);
            Swal.fire({
              icon: 'error',
              title: 'Error al guardar',
              text: 'Ocurrió un error al guardar el registro, por favor vuelve a intentarlo.'
            });
          }
        );
  }

  guardarDiagrama() {
    if (this.firstFormGroup.valid 
      && this.selectedPromotions.length > 0 
      && this.stores_sel.length > 0
      && (this.vobos_sel.length == this.phases.length)
      && (!this.precio_sel.some((p:any)=>p.precio < 0 || !/^-?\d+(\.\d+)?$/.test(String(p.precio)) ))
    ) {
      this.guardandoDiagrama = true;
      this.main.ShowLoading();
     const preciosMap = new Map(this.precio_sel.map((p: any) => [p.id_pop_config, p.precio]));
      const precios = this.dt_totales.map((e: any) => {
        if (preciosMap.has(e.id_pop_config)) {
          return { ...e, precio: preciosMap.get(e.id_pop_config) };
        }
        return e;
      });

     // let sucs_diag = this.projectDiagramations.filter((e:any)=>e.id_medio==this.medio_sel.id).map((diagram: any) =>
      //   diagram.pop_config.map((pc: any) => pc.sucursales)).flat();
    
      let ins_data = { 
        ...this.firstFormGroup.value,
        imprime: this.firstFormGroup.get('imprime')?.value ?? true,
        id_proyecto: this.id_proy,
        promociones: this.selectedPromotions,
        fases: this.vobos_sel,
        sucursales: this.stores_sel,
        precios
      };
 
     
      if( !this.pop_sel.posiciones || this.pop_sel.posiciones  == 0){
        const positions = this.diagram_sim_pop.map((e:any)=>e.posicion);
        ins_data.position = positions.length + 1;
      }else{
        ins_data.position = this.position_sel;
      }

      //Añadir los archivos (uno por uno)
      this.selectedFiles.forEach((file, index) => {
        this.formData.append(`blob_${index}`, file);
      });
      this.formData.append('folder', this.project.folder as string);      

      
      if(this.edit) {
        ins_data.id_diagrama = this.curr_diagram.id;
        
        this.projectsS.editProjectDiagram(ins_data).subscribe(
          (result:any) => {
            this.main.HideLoading();
            if(result.message == "Success") {

              if(this.selectedFiles.length > 0){
                this.formData.append('id_diagrama', result.id_diagrama);      
                this.uploadImages();
              }
              else{
                  Swal.fire({
                  icon: 'success',
                  title: 'Editado',
                  text: 'Diagrama editado correctamente'          
                }).then(() => {            
                  this.dialogRef.close({ reload: true });
                });
              }
              
            }
            else {
               this.main.HideLoading();
               this.guardandoDiagrama = false;
              Swal.fire({
                icon: 'error',
                title: 'Error al guardar',
                text: 'Ocurrió un error al guardar el registro, por favor vuelve a intentarlo.'
              });
            }
          },
          (err:any) => {
            this.main.HideLoading();
                  this.guardandoDiagrama = false;
            console.log(err);
            Swal.fire({
              icon: 'error',
              title: 'Error al guardar',
              text: 'Ocurrió un error al guardar el registro, por favor vuelve a intentarlo.'
            });
          }
        );
      }
      else {
        this.validarGuardado(ins_data).then((x)=>{
          if(x.isValid){
          this.guardandoDiagrama = false;
          this.projectsS.newProjectDiagram(ins_data).subscribe(
          (result:any) => {
            if(result.message == "Success") {
              this.revalidarGuardardo(ins_data, result.id_diagrama).then((x)=>{
                this.main.HideLoading();
                this.guardandoDiagrama = false;
                if(x.isValid){
                    if(this.selectedFiles.length > 0){
                      this.formData.append('id_diagrama', result.id_diagrama);      
                      this.uploadImages();
                    }
                    else{
                        Swal.fire({
                        icon: 'success',
                        title: 'Creado',
                        text: 'Diagrama creado correctamente'          
                      }).then(() => {            
                        this.dialogRef.close({ reload: true });
                      });
                    }
                }else{
                   this.projectsS.deleteProjectDiagram(result.id_diagrama).subscribe(
                     (result:any) => {
                         Swal.fire({
                           icon: 'warning',
                           title: 'No es posible guardar',
                           text: "No hay inventario disponible para diagramar." 
                         });

                        this.resetDiagram(ins_data.medio)
                        
                     },
                     (err:any) => {
                       console.log(err);
                          Swal.fire({
                            icon: 'warning',
                            title: 'No es posible guardar',
                            text: "No hay inventario disponible para diagramar." 
                          });
                            this.resetDiagram(ins_data.medio)
                     }
                   );  
                }
              });
                
            }
            else {
              this.guardandoDiagrama = false;
              if(result.message== "Invalid"){
                  Swal.fire({
                    icon: 'warning',
                    title: 'No es posible guardar',
                    text: result.error_msg + " Por favor, verifique el medio e intente de nuevo más tarde."
                  });
                   this.resetDiagram(ins_data.medio)
              }else{
                this.main.HideLoading();
               Swal.fire({
                icon: 'error',
                title: 'Error al guardar',
                text: 'Ocurrió un error al guardar el registro, por favor vuelve a intentarlo.'
              });
              }

            }
          },
          (err:any) => {
            this.guardandoDiagrama = false;
            this.main.HideLoading();
            console.log(err);
            Swal.fire({
              icon: 'error',
              title: 'Error al guardar',
              text: 'Ocurrió un error al guardar el registro, por favor vuelve a intentarlo.'
            });
          }
        );
        }else{
          this.main.HideLoading();
          if(x.isMediaType){
            //regrese a seleccion de medios
                  Swal.fire({
                    icon: 'warning',
                    title: 'No es posible guardar',
                    text: x.message + " Por favor, verifique el medio e intente de nuevo más tarde."
                  });
                   this.resetDiagram(ins_data.medio)
                 // this.stores_sel = [];
          }else{
            //regreso a seleccion de susursales (llamar a seconddata)
            if(x.isPositionError){
                  Swal.fire({
                    icon: 'warning',
                    title: 'No es posible guardar',
                    text: x.message + " Por favor, verifique los datos e intente de nuevo más tarde."
                  });
                   this.resetDiagram(ins_data.medio)
                // this.stores_sel = [];
            }else{
              
                  Swal.fire({
                    icon: 'warning',
                    title: 'No es posible guardar',
                    text: x.message ? x.message : "El listado de sucursales ha cambiado debido a que el inventario se actualizó, por favor, verifique las sucursales seleccionadas."
                  });
                 // this.stores_sel = [];
                   this.resetDiagram(ins_data.medio)
               
            }
           
          }
        }
        });
      }
    }
    else {
      Swal.fire({
         icon: 'warning',
          title: 'Datos incorrectos',
          text: 'Los datos ingresados no son validos.'
      });
    }
  }

  applyFilter(event: Event, ds: any) {
    const filterValue = (event.target as HTMLInputElement).value;
    ds.filter = filterValue.trim().toLowerCase();
    if (ds.paginator) ds.paginator.firstPage();
  }

  columnFiltersPromo: { [key: string]: string } = {};
  toggleSoloSeleccionados: boolean = false;

  applyColumnFilterPromo(column: string, event: Event) {
    this.selectAllValue = false;
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.columnFiltersPromo[column] = filterValue;

    this.actualizarFiltroTabla(); 
    /* this.dspromotionFile.filter = JSON.stringify(this.columnFiltersPromo);
    if (this.dspromotionFile.paginator) {
      this.dspromotionFile.paginator.firstPage();
    } */
    //this.dspromotionFile._updateChangeSubscription();
  }

  actualizarFiltroTabla() {

    const filtroGlobal = {
      columnas: this.columnFiltersPromo,
      seleccionados: this.selectedPromotions,
      soloSeleccionados: this.toggleSoloSeleccionados,
      search: this.searchTextProm
    };

    this.dspromotionFile.filter = JSON.stringify(filtroGlobal);

    if (this.dspromotionFile.paginator) {
      this.dspromotionFile.paginator.firstPage();
    }
  }

  columnFiltersStores: { [key: string]: string } = {};

  doToggleValue(){
    this.toggleValue = !this.toggleValue;
  }

  doSelectAllValue(){
    this.selectAllValue =  !this.selectAllValue;
  }

  applyColumnFilterStores(column: string, event: Event) {
    this.toggleValue = false;
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.columnFiltersStores[column] = filterValue;

    this.dsstoreFile.filter = JSON.stringify(this.columnFiltersStores);
    if (this.dsstoreFile.paginator) {
      this.dsstoreFile.paginator.firstPage();
    }
    this.dsstoreFile._updateChangeSubscription();
    this.cdr.detectChanges();
  }

  applyColumnFilterStoresSelect(column: string, event: any) {
    this.toggleValue = false;
    const filterValue = event.trim().toLowerCase();
    this.columnFiltersStores[column] = filterValue;

    this.dsstoreFile.filter = JSON.stringify(this.columnFiltersStores);
    if (this.dsstoreFile.paginator) {
      this.dsstoreFile.paginator.firstPage();
    }
    this.dsstoreFile._updateChangeSubscription();
    this.cdr.detectChanges();
  }
  
  farmidsInput : string = "";

  takeFarmIdsInput(){
    /* const regex = /^(\s*\w+\s*)(,\s*\w+\s*)*$/; 
    if(regex.test(this.farmidsInput)){
      let famIds : Array<any> = [];
      famIds = this.farmidsInput
      .split(',')
      .map(farmid => farmid.trim()) 
      .filter(farmid => farmid !== '');

      this.selectStoresByArray(famIds);
      
      this.farmidsInput = "";
    }else{
      Swal.fire({
        icon: 'warning',
        title: 'No se pudieron seleccionar',
        text: 'El formato indicado no es el correcto, deben ser IDs separados por comas pe."1243,1344,1342"'
      });
    } */

    let famIds: Array<any> = [];

    famIds = this.farmidsInput
      .split(/[\s,]+/)
      .map(codigo => codigo.trim())
      .filter(codigo => codigo !== '');

    if (famIds.length > 0) {

      this.selectStoresByArray(famIds);
      this.farmidsInput = "";

    } else {

      Swal.fire({
        icon: 'warning',
        title: 'No se pudieron seleccionar',
        text: 'Ingresa FarmIDs válidos separados por comas, espacios, o tabulador.'
      });

    }
  }

  selectStoresByArray(arrayIds : Array<any>){
    this.main.ShowLoading();
    let count = 0;
    arrayIds.forEach(idfarm=>{
      setTimeout(()=>{    
        let farm = this.storeFile.filter((x:any)=>  x.FarmID.toLowerCase() == idfarm.trim().toLowerCase())
         
        if(farm.length != 0){
          let index = this.selectedStores.indexOf(farm[0].id);
          if (index > -1) {
            //hacer algo
          } else {
            this.toggleSelectionStore(farm[0].id, { target: { checked: true }});
          }
        }    
          
        count ++;
        if(arrayIds.length == count){
          this.main.HideLoading();
        }
      }, 20);
    });
  }

  async onExcelSelected(event: any) {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (e: any) => {
      const data:any = new Uint8Array(e.target.result);
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(data);
      
      const worksheet = workbook.worksheets[0]; 

      this.extractFarmIDs(worksheet);
    };

    reader.readAsArrayBuffer(file);
    event.target.value = null;

  }

  extractFarmIDs(worksheet: ExcelJS.Worksheet) {
    const farmIdColumnName = 'FarmID'; 
    let columnIdx: number | undefined;

    worksheet.getRow(1).eachCell((cell, colNumber) => {
      if (cell.value === farmIdColumnName) {
        columnIdx = colNumber;
      }
    });

    if (!columnIdx) {
      Swal.fire({
        icon: 'warning',
        title: 'No se pudieron seleccionar las sucursales',
        text: 'El archivo no contiene la columna FarmID'
      });
      return;
    }

    let farmIdsArray: Array<any> = [];
    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber > 1) { 
        const farmID = row.getCell(columnIdx!).value;
        if (farmID) {
          farmIdsArray.push(String(farmID));
        }
      }
    });

    this.selectStoresByArray(farmIdsArray);
    //console.log('FarmIDs añadidos:', farmIdsArray);
  }

  
  generateSucExcel(){
    if(this.dsstoreFile.data.length == 0){
      Swal.fire({
        icon: 'warning',
        title: 'Aviso',
        text: 'No hay Sucursales para generar el Excel'
      }).then(s=>{
  
      });
    }else{
      const dataExcel = JSON.parse(JSON.stringify(this.dsstoreFile.data));
      dataExcel.map((e :any)=>{
        delete e.id;
        return e;
      });
      this.main.generateExcel( dataExcel, "Sucursales", "Sucursales");
    }
  }

  codigosPrincipalInput : string = "";

  takeCodigosPrincipalInput(){
    /* const regex = /^(\s*\w+\s*)([,\t]\s*\w+\s*)*$/; 
    if(regex.test(this.codigosPrincipalInput)){
      let codigosP : Array<any> = [];
      codigosP = this.codigosPrincipalInput
      .split(/[,\t]/)
      .map(codigo => codigo.trim()) 
      .filter(codigo => codigo !== '');

      this.selectPromocionesByArray(codigosP);
      
      this.codigosPrincipalInput = "";
    }else{
      Swal.fire({
        icon: 'warning',
        title: 'No se pudieron seleccionar',
        text: 'El formato indicado no es el correcto, deben ser códigos separados por comas, ejemplo: "1243,1344,1342"'
      });
    } */

      let codigosP: Array<any> = [];

      codigosP = this.codigosPrincipalInput
        .split(/[\s,]+/)
        .map(codigo => codigo.trim())
        .filter(codigo => codigo !== '');

      if (codigosP.length > 0) {

        this.selectPromocionesByArray(codigosP);
        this.codigosPrincipalInput = "";

      } else {

        Swal.fire({
          icon: 'warning',
          title: 'No se pudieron seleccionar',
          text: 'Ingresa códigos válidos separados por comas, espacios, o tabulador.'
        });

      }
  }

  selectPromocionesByArray(arrayIds : Array<any>){
    this.main.ShowLoading();
    let count = 0;

    arrayIds.forEach(codigo=>{
      setTimeout(()=>{    
        let prom = this.promotionFile.filter((x:any)=>  String(x["CODIGO PRINCIPAL"] ?? '').toLowerCase() == codigo.trim().toLowerCase())
         
        if(prom.length != 0){
          let index = this.selectedPromotions.indexOf(prom[0]["CODIGO PRINCIPAL"]);
          if (index > -1) {
            //hacer algo
          } else {
            this.toggleSelection(prom[0]["CODIGO PRINCIPAL"]);
          }
        }    
          
        count ++;
        if(arrayIds.length == count){
          this.main.HideLoading();
        }
      }, 20);
    });
  }

  generatePromExcel(){
    if(this.dspromotionFile.data.length == 0){
      Swal.fire({
        icon: 'warning',
        title: 'Aviso',
        text: 'No hay promociones para generar el excel'
      }).then(s=>{
  
      });
    }else{
      const datosFiltrados = this.dspromotionFile.filteredData.map((item: any)=> {
        return this.displayedColumns.reduce((obj:any, clave) => {
          if (item.hasOwnProperty(clave)) {
            obj[clave] = item[clave];
          }
          return obj;
        }, {});
      });
      const dataExcel = JSON.parse(JSON.stringify(datosFiltrados));
      dataExcel.map((e :any)=>{
        delete e.id;
        return e;
      });
      this.main.generateExcel( dataExcel, "Promociones", "Promociones");
    }
  }

  async onExcelSelectedProm(event: any) {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (e: any) => {
      const data:any = new Uint8Array(e.target.result);
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(data);
      
      const worksheet = workbook.worksheets[0]; 

      this.extractCodigoSeleccionados(worksheet);
    };

    reader.readAsArrayBuffer(file);
    event.target.value = null;

  }

  extractCodigoSeleccionados(worksheet: ExcelJS.Worksheet) {
    const columnName = 'CODIGO PRINCIPAL'; 
    let columnIdx: number | undefined;

    worksheet.getRow(1).eachCell((cell, colNumber) => {
      if (cell.value === columnName) {
        columnIdx = colNumber;
      }
    });

    if (!columnIdx) {
      Swal.fire({
        icon: 'warning',
        title: 'No se pudieron seleccionar las promociones',
        text: 'El archivo no contiene la columna CODIGO PRINCIPAL'
      });
      return;
    }

    let codigosArray: Array<any> = [];
    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber > 1) { 
        const codeSelec = row.getCell(columnIdx!).value;
        if (codeSelec) {
          codigosArray.push(String(codeSelec));
        }
      }
    });

    this.selectPromocionesByArray(codigosArray);
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
 
      // Filtrar solo imágenes o PDFs o ZIPs
     const validFiles = Array.from(input.files).filter(file =>
       file.type.startsWith('image/') ||
       file.type === 'application/pdf' ||
       file.type === 'application/zip' ||
       file.name.toLowerCase().endsWith('.zip')
     );
      if (validFiles.length !== input.files.length) {
        Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Solo se permiten imágenes o archivos PDF'
        });
        input.value = '';
      }

      this.selectedFiles = validFiles;
      this.firstFormGroup.get('blob')?.setValue(this.selectedFiles);
    }
  }

  uploadImages(){

    this.projectsS.setImagesDiagramation(this.formData).subscribe(
              (result:any) => {
                this.main.HideLoading();
                if(this.edit) {
                  if(result.message == "Success") {
                    Swal.fire({
                      icon: 'success',
                      title: 'Editado',
                      text: 'Diagrama editado correctamente'          
                    }).then(() => {            
                      this.dialogRef.close({ reload: true });
                    });
                  }
                  else {
                    Swal.fire({
                      icon: 'error',
                      title: 'Error al editar',
                      text: 'Ocurrió un error al editar el registro, por favor vuelve a intentarlo.'
                    });
                  }
                }
                else{
                  if(result.message == "Success") {
                    Swal.fire({
                      icon: 'success',
                      title: 'Creado',
                      text: 'Diagrama creado correctamente'          
                    }).then(() => {            
                      this.dialogRef.close({ reload: true });
                    });
                  }
                  else {
                    Swal.fire({
                      icon: 'error',
                      title: 'Error al guardar',
                      text: 'Ocurrió un error al guardar el registro, por favor vuelve a intentarlo.'
                    });
                  }
                }
              },
              (err:any) => {
                this.main.HideLoading();
                console.log(err);
                Swal.fire({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: 'Ocurrió un error al guardar el registro, por favor vuelve a intentarlo.'
                });
              }
            );

  }

  verImagenes(resp: any){
    this.matDialog.open(ProjectDiagramationImagesComponent, {
      panelClass: ['dialogs-md'],
        data: {
          ...resp,
          type: 2
        }
      }).afterClosed().subscribe(
      resp => {
      }
    );
  }

  getImages(){
      if(this.edit) { 
      this.projectsS.getImagesDiagramation(this.curr_diagram.id,2).subscribe(
        (result:any) => {
          this.images = result.data;
          this.main.HideLoading();
        },
        (err:any) => {
          console.log(err);
          Swal.fire({
            icon: 'error',
            title: 'Error al obtener imágenes',
            text: 'Ocurrió un error al obtener las imágenes, por favor vuelve a intentarlo.'
          });
        }
      );
    }
  }

  openModalAddPlantilla() {
    this.matDialog.open(ProjectAddPlantillaComponent, {
      panelClass: ['dialogs-md'],
      data: {
        phases: this.phases,
        id_proy: this.id_proy
      }
    }).afterClosed().subscribe(
      resp => {
        this.getPlantillas(2);
        if(resp){
          this.plantillaSeleccionada = resp;
          this.id_plantSel = resp;
        }
      }
    );
  }

  getPlantillas(tipo: number) {
    this.projectsS.getPlantillasVobos(this.id_proy).subscribe(
      (result: any) => {
        this.plantillas = result.data;

        if(this.edit && tipo == 1){
          //Para seleccionar la plantilla en el select (si es que se uso al crear la diagramacion o los vobos son igual a una plantilla)
          //Itero sobre plantillas para quitar fechas porque son diferentes a array de this.phases
          const plantillasSinFecha = this.plantillas.map(plantilla => {
            const nuevaPlantilla = { ...plantilla };
            const pv = JSON.parse(nuevaPlantilla.phases_vobos)

            pv.map( (x:any) => {
              delete x.fecha_limite;
              x.vobos.forEach( (vobo:any) => {
                delete vobo.fecha_limite;
              });
            })   
            
            nuevaPlantilla.phases_vobos = pv;
            return nuevaPlantilla;
          });
          
          //Itero sobre el this.phase para quitar fechas
          const phaseSinFecha = this.phases.map((item: any) => {
            const newFases = item;
              delete newFases.fecha_limite;
              newFases.vobos.forEach( (vobo:any) => {
                delete vobo.fecha_limite;
              });
              return newFases           
          });

          //Filtro para obtener la plantilla
          const filterPlantillaSel = plantillasSinFecha.filter( x => JSON.stringify(x.phases_vobos) == JSON.stringify(phaseSinFecha));
          if(filterPlantillaSel.length > 0){ //La selecciono en el select
            this.plantillaSeleccionada =  filterPlantillaSel[0].id;
          }
        }

      },
      (err: any) => {
        console.log(err);
        Swal.fire({
          icon: 'error',
          title: 'Error al obtener plantillas',
          text: 'Ocurrió un error al obtener las plantillas'
        });
      }
    );
  }

  cargaVobosPlantilla(idpl: number) {
    this.arrPlantilla = [];
    this.id_plantSel = idpl;

    const resultado = this.plantillas.find((obj: any) => obj.id === idpl);

    if (resultado) {
      this.arrPlantilla = JSON.parse(resultado.phases_vobos)
    }

    this.phases.forEach((obj1: any) => {
      //Para cada objeto del primer array, buscamos el correspondiente en el segundo
      const obj2 = this.arrPlantilla.find((o: any) => o.id === obj1.id);
      if (obj2) {
        //Recorremos los vobos del objeto actual del primer array
        obj1.vobos.forEach((vobo1: any) => {
          //Buscamos el vobo correspondiente en el objeto del segundo array por el área
          const vobo2 = obj2.vobos.find((v: any) => v.area === vobo1.area);
          //Si encontramos una coincidencia de área
          if (vobo2) {
            //Asignamos el selectedUsers del primero al segundo
            vobo1.selectedUsers = vobo2.selectedUsers;
          }
        });
      }
    });

    this.phases.forEach((phase: any) => {
      const cumple = phase.vobos.every((vobo: any) => vobo.optional == true || vobo.selectedUsers.length > 0);
      phase.selected = cumple; // si todos cumplen true, si no false
      phase.vobos.forEach((vobo: any) => {
        this.onUserSelectionChange(phase.id)
      })
    });
    this.selectedVobos = this.phases.every((phase: any) =>
      phase.vobos.every((vobo: any) => vobo.optional== true || vobo.selectedUsers.length > 0)
    );

    this.actualizaLabels();
  }

  actualizaLabels() {
    this.phases.forEach((phase: any) => {
      const totalSelected = Object.values(phase.vobos).filter((ph: any) => {
        return ph.optional== true|| (ph.selectedUsers && ph.selectedUsers.length > 0);
      }).length;
      phase.totalVobosSelected = totalSelected;
    })

    const totalFasesConf = Object.values(this.phases).filter((ph: any) => {
      return ph.selected;
    }).length;
    this.totalPhasesConfiguradas = totalFasesConf;
  }

  toggleSelectAllUsers(item: any, phaseId: number) {
    const allUserIds = item.users.map((u: any) => u.id);
    const allSelected = allUserIds.every((id: number) => item.selectedUsers.includes(id));

    if (allSelected) {
      item.selectedUsers = [];
    } else {
      item.selectedUsers = [...allUserIds];
    }

    this.onUserSelectionChange(phaseId);
    this.filterUsers(item);
  }

  actualizarPlantilla() {
    this.projectsS.updatePlantillaVobos(this.id_plantSel, this.phases).subscribe(
      (result: any) => {
        if (result.message == "Success") {
          Swal.fire({
            icon: 'success',
            title: 'Actualizada',
            text: ''
          }).then(() => {
            this.getPlantillas(2);
            this.alertEditPlantilla = true;
          });
        }
      },
      (err: any) => {
        console.log(err);
        Swal.fire({
          icon: 'error',
          title: 'Error al actualizar plantilla',
          text: 'Ocurrió un error al actualizar plantilla'
        });
      }
    );
  }

  eliminarPlantilla() {
    this.projectsS.deletePlantillaVobos(this.id_plantSel).subscribe(
      (result: any) => {
        if (result.message == "Success") {
          Swal.fire({
            icon: 'success',
            title: 'Eliminada',
            text: ''
          }).then(() => {
            this.getPlantillas(2);
          });
        }
      },
      (err: any) => {
        console.log(err);
        Swal.fire({
          icon: 'error',
          title: 'Error al eliminar plantilla',
          text: 'Ocurrió un error al eliminar plantilla'
        });
      }
    );
  }

  async validarGuardado(ins_data:any): Promise<any> {
    try {
      await this.refreshDataDiagramationAsync();
      // empiezo a validar sucursales
      // replico getInventory para obtener los dt_totales

      const popsResponse: any = await new Promise((resolve, reject) => {
        this.projectsS.getPOPs(this.medio_sel.id).subscribe({
          next: (res:any) => resolve(res),
          error: (err:any) => reject(err)
        });
      });
      let curr_pop_sel = popsResponse.data.elementos_pop.find((e:any)=>e.id==ins_data.elemento_pop);
      
      let dt_totales_validation: any = [];
      await this.getInventory(true).then((res_dt_totales: any) => {
        if (this.medio_sel.inventario_type == 1) {
          dt_totales_validation = res_dt_totales.filter((rd: any) => rd.id_medio == this.medio_sel.id);
        } else {
          dt_totales_validation = res_dt_totales.filter((rd: any) => rd.id_medio == this.medio_sel.id && rd.id_pop == curr_pop_sel.id);
        }
        dt_totales_validation = Array.from(
          new Map(dt_totales_validation.map((item: any) => [item.atributo, item])).values()
        );
      });
  

      const created_diagramations = this.projectAllDiagramations.filter((e: any) => e.id_medio == this.medio_sel.id);
      const used_el = popsResponse.data.elementos_pop.map((e: any) => {
        const positions = new Set(
          created_diagramations
            .filter((a: any) => a.id_pop == e.id)
            .map((a: any) => a.posicion)
        );
        return { pop: e.nombre, positions: positions.size };
      });

      const availableElements = popsResponse.data.elementos_pop.filter((e: any) => {
        const f = used_el.find((a: any) => a.pop == e.nombre);
        return ((!e.posiciones || e.posiciones == 0) || (f?.positions ?? 0) < e.posiciones);
      });

      if (availableElements.length === 0 && !this.edit) {
        return { isValid: false, message: "El medio seleccionado no tiene elementos disponibles para diagramar.", isMediaType: true };
      }
      

     // let curr_diagram_sim_pop = this.projectDiagramations.filter((e:any)=>e.id_medio==this.medio_sel.id&&e.id_pop==ins_data.elemento_pop);
     let diagramedPositions : any[]= [];
      if (curr_pop_sel?.posiciones > 0) {
         diagramedPositions = this.projectAllDiagramations
          .filter((x: any) => x.id_medio == this.medio_sel.id && x.id_pop == curr_pop_sel.id)
          .map((p: any) => p.posicion);

        const allPositions = Array.from({ length: curr_pop_sel.posiciones }, (_, i) => i + 1);
        const availablePositions = allPositions.filter(p => !diagramedPositions.includes(p));

        if (!this.edit) {
          if (availablePositions.length === 0) {
            return { isValid: false, message: "Ya no quedan posiciones disponibles para diagramar con los datos seleccionados.", isPositionError: true };
          }
          if (diagramedPositions.includes(ins_data.position)) {
            return { isValid: false, message: "No es posible crear la diagramación con los datos seleccionados.", isPositionError: true };
          }
        }
      }

  
      // funcionalidad de configSelected para obtener storeFile 
      let storeFile_validation: any = [];
      //const arr_reglas_validation: any = [];
      //this.materiales_dist.forEach((config: any) => {
      //  let r: any = {};
      //  if (this.medio_sel.formato == 3) {
      //    r = JSON.parse(this.medio_sel.prioridad_filtro)[0];
      //    r.cant_type = 4;
      //  } else if (this.medio_sel.formato == 2) {
      //    r = JSON.parse(this.medio_sel.prioridad_filtro)[0];
      //    r.cant_type = 3;
      //  } else if (!config.reglas_distribucion || config.reglas_distribucion.length == 0 || config.reglas_distribucion == "[]" || this.isEmpyConfig(config.reglas_distribucion)) {
      //    r = { cant_type: 1, multiplicador: config.cantidad, nombre: config.nombre };
      //  } else {
      //    r = JSON.parse(config.reglas_distribucion)[0];
      //    r.cant_type = 2;
      //  }
      //  arr_reglas_validation.push(r);
      //});
  
      // let filtros: any = [];
      // if (this.pop_sel.sucursales_filtro) filtros = JSON.parse(this.pop_sel.sucursales_filtro);
      // if (this.medio_sel.sucursales_filtro) filtros = [...filtros, ...JSON.parse(this.medio_sel.sucursales_filtro)];
      
      //storeFile_validation = this._cutoffS.filtrarSucursales(filtros);
      storeFile_validation  = this._cutoffS.project_cutoff_file_data;
  
      // aplicar filtros de diagramaciones existentes
      if (!this.same_stores) {
        if (this.medio_sel.multiples_elementos == 0 && this.edit) {
          const ids_suc_sel = this.projectAllDiagramations
            .filter((e: any) => e.id_medio == this.medio_sel.id && e.id !== this.curr_diagram.id)
            .map((d: any) => d.pop_config.map((pc: any) => pc.sucursales.map((s: any) => s.id)).flat()).flat();
          if (ids_suc_sel.length > 0) {
            storeFile_validation = storeFile_validation.filter((e: any) => !ids_suc_sel.includes(e.id));
          }
        }
      }
  
      const availableStoreIds = new Set(storeFile_validation.map((s: any) => s.id));
  
      // ahora si valido
      //  si alguna sucursal seleccionada ya no esta disponible
      const missingStores = this.selectedStores.filter(id => !availableStoreIds.has(id));
      if (missingStores.length > 0) {
        return { isValid: false, message: "Las siguientes sucursales seleccionadas ya no están disponibles: " + missingStores.join(', ') + "." };
      }
      // si la cantidad seleccionada excede el inventario disponible, solo para la primera posicion.
     // if(ins_data.position == 1){
      if(diagramedPositions.length == 0){
        for (const sel of this.stores_sel) {
          //const inventoryInfo = dt_totales_validation.find((dt: any) => dt.id_pop_config === sel.id_pc);
          const mediaInv = dt_totales_validation.find((dt: any) => dt.items.some((c: any)=>c.id_pop_config == sel.id_pc))
          if(mediaInv) {
            const inventoryInfo = mediaInv.items.find((dt: any) => dt.id_pop_config == sel.id_pc);
            if (inventoryInfo) {
              // recalcular el total seleccionado para este material, considerando solo las sucursales que aun estan disponibles.
              const currentSelectedTotal = sel.sucursales
                .filter((s: any) => availableStoreIds.has(s.id))
                .reduce((acc: number, s: any) => acc + Number(s.cantidad), 0);
       
              // se suma lo que ya estaba seleccionado en otras diagramaciones (el inventario disponible ya lo descuenta)
              const totalPreviouslySelected = inventoryInfo.seleccionado;
              let inventarioReal = 0;
              if(this.medio_sel.formato == 1){
                inventarioReal = mediaInv.inventario;
              }else{
                 inventarioReal = inventoryInfo.inventario;
              }
               
              if ((currentSelectedTotal + totalPreviouslySelected) >  inventarioReal) {
                return { 
                  isValid: false, 
                  message: "La cantidad seleccionada para el material \"" + inventoryInfo.nombre + "\" (" + currentSelectedTotal + ") sumada a lo ya seleccionado (" + totalPreviouslySelected + ") excede el inventario disponible de (" + inventoryInfo.inventario + ")."
                  , isMediaType: false
                };
              }
            } else {
                //esto no deberia pasar pero por si acaso.
                return { isValid: false, message: "No se encontró información de inventario para el material: " + sel.id_pc + "." };
            }
          } else {
                //esto no deberia pasar pero por si acaso.
                return { isValid: false, message: "No se encontró información de inventario para el material: " + sel.id_pc + "." };
            }
        }
      }

      return { isValid: true, message: "La selección es válida." };
  
    } catch (error) {
      console.error("Error durante la validación de la selección:", error);
      return { isValid: false, message: 'Ocurrió un error al validar la selección. Por favor, inténtelo de nuevo.' };
    }
  }

   async revalidarGuardardo(ins_data : any, id_diagrama : number): Promise<any> {
          let curr_pop_sel = this.pop_sel;
          let dt_totales_validation: any = [];
           await this.getInventory(true).then(async (res_dt_totales: any) => {
             await this.refreshDataDiagramationAsync();
             if (this.medio_sel.inventario_type == 1) {
               dt_totales_validation = res_dt_totales.filter((rd: any) => rd.id_medio == this.medio_sel.id);
             } else {
               dt_totales_validation = res_dt_totales.filter((rd: any) => rd.id_medio == this.medio_sel.id && rd.id_pop == curr_pop_sel.id);
             }
             dt_totales_validation = Array.from(
               new Map(dt_totales_validation.map((item: any) => [item.atributo, item])).values()
             );
           });
         
         let storeFile_validation: any = [];
          
         if (!this.same_stores) {
           if (this.medio_sel.multiples_elementos == 0 && this.edit) {
             const ids_suc_sel = this.projectAllDiagramations.filter((e: any) => e.id != id_diagrama)
               .filter((e: any) => e.id_medio == this.medio_sel.id)
               .map((d: any) => d.pop_config.map((pc: any) => pc.sucursales.map((s: any) => s.id)).flat()).flat();
             if (ids_suc_sel.length > 0) {
               storeFile_validation = storeFile_validation.filter((e: any) => !ids_suc_sel.includes(e.id));
             }
           }
         }
        
         const availableStoreIds = new Set(storeFile_validation.map((s: any) => s.id));
          let diagramedPositions = this.projectAllDiagramations
          .filter((x: any) => x.id_medio == this.medio_sel.id && x.id_pop == curr_pop_sel.id && x.id != id_diagrama)
          .map((p: any) => p.posicion);

          if(diagramedPositions == 0){
          for (const sel of this.stores_sel) {
            const mediaInv = dt_totales_validation.find((dt: any) => dt.items.some((c: any)=>c.id_pop_config == sel.id_pc))
              if(mediaInv) {
              const inventoryInfo = mediaInv.items.find((dt: any) => dt.id_pop_config == sel.id_pc);
                // recalcular el total seleccionado para este material, considerando solo las sucursales que aun estan disponibles.
                const currentSelectedTotal = sel.sucursales
                  .filter((s: any) => availableStoreIds.has(s.id))
                  .reduce((acc: number, s: any) => acc + Number(s.cantidad), 0);
              
                // se suma lo que ya estaba seleccionado en otras diagramaciones (el inventario disponible ya lo descuenta)
              const totalPreviouslySelected = inventoryInfo.seleccionado;
              let inventarioReal = 0;
              if(this.medio_sel.formato == 1){
                inventarioReal = mediaInv.inventario;
              }else{
                 inventarioReal = inventoryInfo.inventario;
              }
               
              if ((currentSelectedTotal + totalPreviouslySelected) >  inventarioReal) {

                  //checo si hay otra diagramación con los mismos datos mas antigua, si hay mas antigua, entonces descarto la que estoy evualuando y mando error, sino, la validacion es correcta
                  let diagramasSameData = this.projectAllDiagramations.filter((e: any) => e.id_medio == this.medio_sel.id);
                  const diagramasMasAntiguos = diagramasSameData.some((d:any)=>d.id < id_diagrama );
                  if(!diagramasMasAntiguos){
                      return { isValid: true, message: "La selección es válida." };
                  }else{ 
                        return { 
                        isValid: false, 
                        message: "La cantidad seleccionada para el material \"" + inventoryInfo.nombre + "\" (" + currentSelectedTotal + ") sumada a lo ya existente (" + totalPreviouslySelected + ") excede el inventario disponible (" + inventoryInfo.inventario + ")."
                        , isMediaType: false
                      };
                  }

                }   
              } else {
                  //esto no deberia pasar pero por si acaso.
                  return { isValid: false, message: "No se encontró información de inventario para el material: " + sel.id_pc + "." };
              }
          }
        
      }
       return { isValid: true, message: "La selección es válida." };
   }

  // Existing methods for real-time updates (already in diff)
  onIndividualPriceInput(material: any) {
    const total = this.findMaterialTotal(material.id_pop_config);
    if (total > 0) {
      material.precioTotal = (material.precio || 0) * total; // Ensure material.precio is treated as 0 if null/undefined
    } else {
      material.precioTotal = 0;
    }
    // Ensure the value passed to setPrecio is a number
    this.setPrecio(material.id_pop_config, { target: { value: material.precio || 0 } });
  }

  onTotalPriceInput(material: any) {
    const total = this.findMaterialTotal(material.id_pop_config);
    if (total > 0) {
      material.precio = (material.precioTotal || 0) / total; // Ensure material.precioTotal is treated as 0 if null/undefined
    } else {
      material.precio = 0;
    }
    // Ensure the value passed to setPrecio is a number
    this.setPrecio(material.id_pop_config, { target: { value: material.precio || 0 } });
  }


  initializeTotalPrices() {
    this.dt_totales.forEach((material: any) => {
      material.precioTotal = this.calculateTotalPriceFront(material.precio, this.findMaterialTotal(material.id_pop_config));
    });

    if (this.dataPositions && this.dataPositions.length > 0) {
      this.dataPositions.forEach((material: any) => {

        if (material.diagramado && material.id_diagrama === 0 && (material.precio !== undefined && material.precio !== null)) {
          material.precioTotal = this.calculateTotalPriceFront(material.precio, this.findMaterialTotal(material.id_pop_config));
        } else if (material.diagramado && material.id_diagrama !== 0) {
      
          material.precioTotal = this.calculateTotalPriceFront(material.precio, material.seleccionado);
        }
      });
    };
  }

  //Save promo columnas section
  selectedColumns: string[] = [];
  loadingPromColumns : boolean = true;
  tieneColGuardadas: boolean = true;

  onSelectOpenedChanged(event: boolean){
    if(this.tieneColGuardadas == false){
      this.saveColumnas();
      this.tieneColGuardadas = true;
    }
  }

  saveColumnas(){
    this.main.ShowLoading();
    this.projectsS.setNewColumnasPromociones(this.id_camp,this.selectedColumns).subscribe((x:any)=>{
      this.main.HideLoading(); 
      this.reloadColumnsUser();
    });
  }

  updateColumnas(){
    this.main.ShowLoading();
    this.projectsS.setColumnasPromociones(this.id_camp,this.selectedColumns).subscribe((x:any)=>{
      this.main.HideLoading(); 
      this.reloadColumnsUser();
    });
  }

  toggleSelectAllColumns(item : any) {
    if (this.selectedColumns.length != 0) {
      this.selectedColumns = []; 
    } else {
      this.selectedColumns = [... this.columnsProm]; 
    }
    this.updateColumnas();
  }
  
    loadColumnsByUser(id: number){
    this.projectsS.getColumnsPromotionsByUser(id).subscribe((x: any) => {
      
      this.selectedColumns = x.data ?? [];
      this.loadingPromColumns = false
      if(this.selectedColumns.length == 0){
        this.tieneColGuardadas = false;
        this.selectedColumns = this.columnsProm;
      }
      else{
        const coincidencias = this.selectedColumns.filter(item => this.columnsProm.includes(item));
        this.selectedColumns = coincidencias;
      }
    },
    (err:any) => {
      console.log(err);
    })
  }

  reloadColumnsUser(){
     this.displayedColumns = [... this.selectedColumns];
        if (!this.displayedColumns.includes('CODIGO PRINCIPAL')) {
           this.displayedColumns.unshift('CODIGO PRINCIPAL');
        }
     this.allColumns = ['select', ...this.displayedColumns];     
  }

  toggleSeleccionados(event: any) {
    this.toggleSoloSeleccionados = event.checked;
    this.actualizarFiltroTabla();
  }

  applyGlobalFilter(event: Event) {

    const value = (event.target as HTMLInputElement)
      .value
      .trim()
      .toLowerCase();

    this.searchTextProm = value;

    this.actualizarFiltroTabla();
  }

  getSolicitudes(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.main.ShowLoading();
      this.projectsS.getSolicitudes(this.id_camp, this.id_file, false).subscribe({
        next: (res: any) => {
          this.main.HideLoading();
          if (res.message === "Success"&& res.solicitudes) {
            this.listSolicitudes = res.solicitudes;
            this.lisDataSolicitudes = res.editados;
           // console.log("solicitudes", this.listSolicitudes);
            this.formedSolicitudes = this.listSolicitudes.map((solicitud: any) => {
              const data_solicitud = this.lisDataSolicitudes.filter(
                (data: any) => data.id_solicitud === solicitud.id
              );
              return { ...solicitud, data_solicitud };
            });
  
           // console.log("Solicitudes de usuario formateadas:", this.formedSolicitudes);
            this.mergeSolicitudesIntoPromotions();
          }
          resolve();
        },
        error: (err: any) => {
          this.main.HideLoading();
          console.error("Error al obtener solicitudes:", err);
          reject(err);
        }
      });
    });
  }

  mergeSolicitudesIntoPromotions() {
    this.promotionFile.forEach((promo: any) => {
      // 1. Filtrar solo solicitudes de edición (tipo 1) y pendientes (status 1) para esta promoción.
      const pendingRequests = this.formedSolicitudes
        .filter((s:any) => s.codigo == promo['CODIGO PRINCIPAL'] && s.tipo === 1 && s.status === 1)
        .sort((a:any, b:any) => b.id - a.id);

      if (pendingRequests.length > 0) {
        // 2. Consolidar los cambios de todas las solicitudes, tomando el más nuevo.
        const latestChanges = new Map<string, any>();

        pendingRequests.forEach((solicitud:any) => {
          // 3. Filtrar solo cambios individuales pendientes (estatus 0).
          const pendingChanges = solicitud.data_solicitud.filter((c: any) => c.estatus === 0);
          pendingChanges.forEach((change: any) => {
            if (!latestChanges.has(change.atributo)) { // El sort previo asegura que el primero que se encuentre es el más nuevo.
              latestChanges.set(change.atributo, { ...change, id_solicitud: solicitud.id });
            }
          });
        });

        // 4. Asignar la data consolidada a la promoción.
        promo.solicitud = { data_solicitud: Array.from(latestChanges.values()) };
      } else {
        promo.solicitud = null;
      }
    });
  }

  getChange(solicitud: any, columnName: string): any | null {
    if (!solicitud || !solicitud.data_solicitud) {
      return null;
    }
    return solicitud.data_solicitud.find((change: any) => change.atributo === columnName && change.estatus === 0);
  }

  getRowClass(row: any): string {
    if (row.solicitud?.data_solicitud.length > 0) return 'row-pending-request';
    return '';
  }

  //inventory changes
  getSucsWithInventory(): any {
    this.stores_sel = [];  

    let columnas_total_sel:any = {};
    const sel_sf = this.storeFile;
    
    return this.arr_cant.map((e:any)=> {
      e.cantidad = Number(e.cantidad);
      const ob_pc: any = { id_pc: e.id_pc, sucursales: [], total: 0, atributo: e.atributo }
      const get_diagram = this.curr_diagram_sim.find((d:any)=>d.id_pop_config==e.id_pc);
      if(get_diagram) {
        ob_pc.id_diagrama = get_diagram.id;
      }
      
      sel_sf.map((sf:any)=> {
        let cantidad = 0;
        if(e.tipo == 1) {
          cantidad = e.cantidad;
        }
        else if(e.tipo == 2) { 
          cantidad = (sf[e.atributo]?parseInt(sf[e.atributo]):0)*e.cantidad;
        }
        else if(e.tipo == 3) { 
          const cant_pops = this.cant_pops;
          const cant_total_suc = (sf[e.atributo]?parseInt(sf[e.atributo]):0)*e.cantidad;
          const modulo = cant_total_suc%cant_pops;
          const max = Math.ceil(cant_total_suc/cant_pops);
          const min = Math.floor(cant_total_suc/cant_pops);
          const prioridad = this.pop_sel.prioridad;
          cantidad = Number(prioridad<=modulo?max:min); 

        }else if(e.tipo == 4) { 
          
          let sumaSucursalTotal : number = 0;
          let maxValue = this.storeFile.filter((x:any) => x.id == sf.id)[0][this.arr_reglas.filter((reg:any) =>  reg.cant_type === 4)[0].atributo];
          //all 
          if(this.medio_sel.inventario_type != 1) {
            this.projectAllDiagramations.filter((e:any)=>e.id_medio==this.medio_sel.id).filter((e:any)=>e.id_pop==this.pop_sel.id).forEach((diagram: any) => {
            diagram.pop_config.forEach((pc: any) => {
              pc.sucursales.filter((s:any)=> s.id == sf.id).forEach((s: any) => {
                sumaSucursalTotal += s.cantidad; // suma cantidades de la sucursal seleccionada
                });
              });
            });
          }
          else {
            this.projectAllDiagramations.filter((e:any)=>e.id_medio==this.medio_sel.id).forEach((diagram: any) => {
            diagram.pop_config.forEach((pc: any) => {
              pc.sucursales.filter((s:any)=> s.id == sf.id).forEach((s: any) => {
                sumaSucursalTotal += s.cantidad; // suma cantidades de la sucursal seleccionada
                });
              });
            });
          }

          let valueToAdd = e.cantidad > maxValue ? maxValue : e.cantidad;

          if((sumaSucursalTotal + valueToAdd) > maxValue){
            cantidad = (sumaSucursalTotal + valueToAdd) - maxValue;
          }else{
            cantidad = valueToAdd;
          }
          //redo: reglas de tipo 4
        }
        //this.cant_sel += cantidad;
        columnas_total_sel[e.attributo] += Number(cantidad);

        if(cantidad > 0) {
          ob_pc.sucursales.push({id: sf.id, cantidad});
          //ob_pc.total += cantidad;
       
          ob_pc.total = Number(ob_pc.total) + Number(cantidad); 
        }
      });

      return ob_pc;
    });
  }
  

}
